import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

const baseTranslationSV = {
  title: 'Juridisk information',
  subtitle: 'Uppgifter enligt § 5 DDG (tyska lagen om digitala tjänster)',
  serviceProvider: 'Tjänsteleverantör',
  contactTitle: 'Kontakt',
  addressLabel: 'Adress',
  contactLabel: 'E-postadress',
  professionalTitle: 'Uppgifter om företaget',
  professionLabel: 'Bolagsform',
  businessTypeLabel: 'Typ av verksamhet',
  taxTitle: 'Skatteuppgifter',
  liabilityTitle: 'Ansvarsfriskrivning',
  contentLiabilityTitle: 'Ansvar för innehåll',
  contentLiability: 'Som tjänsteleverantör ansvarar vi enligt § 7 första stycket DDG för vårt eget innehåll på dessa webbsidor. Enligt §§ 8–10 DDG är vi som tjänsteleverantör dock inte skyldiga att övervaka extern information som överförs till eller lagras på vår webbplats.',
  linkLiabilityTitle: 'Ansvar för länkar',
  linkLiability: 'Vårt erbjudande innehåller länkar till externa webbplatser som tillhör tredje part. Vi har inget inflytande över innehållet på dessa webbplatser och kan därför inte ta något ansvar för det. För innehållet på de länkade webbplatserna ansvarar alltid respektive leverantör eller den som driver webbplatsen. De länkade webbplatserna kontrollerades med avseende på eventuella lagöverträdelser när länken skapades.',
  copyrightTitle: 'Upphovsrätt',
  copyright: 'Innehåll och sammanställningar som leverantörerna publicerar på dessa webbsidor omfattas av tysk upphovsrätt. Mångfaldigande, bearbetning, spridning och varje form av utnyttjande utanför upphovsrättens gränser kräver skriftligt medgivande från författaren eller upphovspersonen. Nedladdningar och kopior av dessa webbsidor är endast tillåtna för privat bruk.'
};

export const localeSV = {
  nav: {
    title: 'pAIoneer Labs GmbH',
    home: 'Hem',
    team: 'Team',
    events: 'Evenemang',
    finance: 'Finans-AI',
    teaching: 'Utbildning',
    agenticdev: 'IDD / Agentic Coding',
    iddLegacy: 'Modernisera äldre programvara',
    iddMethod: 'Intent-Driven Development',
    veridion: 'Veridion',
    kyveil: 'Anonymisering',
    quantum: 'Kvant-AI',
    login: 'Logga in',
    openApp: 'Öppna appen',
    account: 'Konto',
    admin: 'Admin',
    logout: 'Logga ut',
    languageNames: { en: 'Engelska', de: 'Tyska', nl: 'Nederländska', uk: 'Ukrainska', fr: 'Franska', it: 'Italienska', es: 'Spanska', sv: 'Svenska', fi: 'Finska', ja: 'Japanska', pl: 'Polska', bg: 'Bulgariska' }
  },
  admin: {
    datalake: {
      loading: "Läser in …",
      loadFailed: "Data laken kan inte nås",
      refresh: "Uppdatera",
      generatedAt: "Läge per",
      notRolled: "Det här området är ännu inte utrullat i backend. Så snart de nya endpointerna är live visas det uppmätta tillståndet här.",
      loadMore: "Ladda fler",
      yes: "ja",
      no: "nej",
      none: "inga",
      close: "Stäng",
      summaryTitle: "Två hypoteser, en arbetsbänk",
      summaryBody: "Arkitekturhypotesen säger: det matematiska kärlet avgör vad modellen kan bli — den finns på LLM-pappersidan. Datahypotesen säger: först länkade, verifierade träningsdata fyller kärlet — den tjänar denna sida. Autopiloten fyller databeståndet löpande, startar träningen när artikelns dataplan är nådd inom varje område på tyska och engelska, mäter resultatet med benchmarksviten och publicerar modellen privat på HuggingFace. Varje siffra här är uppmätt eller markerad som konfigurerat värde.",
      summaryArchButton: "Till arkitekturhypotesen (LLM-papper)",
      apTitle: "Autopilot",
      tpTitle: "Vägen till träningsstarten",
      tpSubtitle: "Var autopiloten står just nu: varje steg fram till den pågående träningen med status, tid och framsteg.",
      tpNow: "Nu",
      tpStep: "Steg",
      tpOf: "av",
      tpSince: "sedan",
      tpFor: "pågår sedan",
      tpHeartbeat: "senaste livstecken",
      tpDone: "klar",
      tpRunning: "pågår",
      tpWaiting: "väntar",
      tpFailed: "misslyckades",
      tpSkipped: "överhoppad",
      tpProgress: "Framsteg",
      tpRows: "rader",
      tpRate: "per sekund",
      tpRemaining: "uppskattad återstående tid",
      tpEstimateNote: "uppskattning från de uppmätta räknarna",
      tpPhaseReading: "läser ett datapaket",
      tpPhaseAdmission: "antagning (dubbletter, entropi)",
      tpPhaseEncoding: "tokenisering",
      tpNoTiming: "Den här motorversionen rapporterar ännu inga tider.",
      tpBlockers: "Blockeringar och fel",
      tpNone: "Inga blockeringar.",
      trTitle: "Träningskörning (live)",
      trSubtitle: "Läses direkt från tränarens körkatalog — fungerar även medan workern startar om.",
      trNoRun: "Ingen träningskörning med förloppsdata ännu.",
      trStateTraining: "tränar",
      trStateStarting: "startar",
      trStateFinished: "klar",
      trStateSilent: "tyst sedan {age}",
      trStep: "Steg",
      trOf: "av",
      trRemaining: "Återstående tid (uppskattning från den uppmätta hastigheten)",
      trSecondsPerStep: "s per steg",
      trProgress: "Förlopp för de planerade stegen",
      trRun: "Körning",
      trResumed: "återupptagen vid steg {step}",
      trVersion: "Träningsdataversion",
      trModel: "Modell",
      trTokensPerSecond: "Tokens/s",
      trTokensSeen: "Sedda tokens",
      trVram: "GPU-minne",
      trCap: "tak",
      trLastHeartbeat: "Senaste heartbeat",
      trAgo: "för {age} sedan",
      trShardReads: "Shard-läsningar lokalt / via workern",
      trLossTitle: "Loss-förlopp",
      trLossTotal: "Totalt",
      trLossNtp: "Nästa token",
      trLossMtp: "Multi-token",
      trChartEmpty: "Inga steg rapporterade ännu.",
      trAxisNote: "Vågrätt: träningssteg, lodrätt: loss (naturlig logaritm). Håll muspekaren över kurvan för att se värdena för ett steg.",
      trValue: "Värde",
      trCurrentValue: "aktuellt",
      trPoints: "{count} mätpunkter totalt",
      trStages: "Läroplanens steg",
      trStageFoundation: "Grund (råtext)",
      trStageCapability: "Förmågor",
      trStageAnneal: "Anneal",
      trStageCurrent: "pågår",
      trStageDone: "klar",
      trStageAhead: "kommer",
      trShards: "shards",
      trRows: "rader",
      trCheckpoint: "Senaste checkpoint",
      trCheckpointNone: "ingen ännu",
      trCheckpoints: "Kompletta checkpoints på disk",
      trCheckpointEvery: "var {minutes}:e minut",
      trKernels: "Aktiva kärnor (kernels)",
      trDeviations: "Avvikelser",
      trBlockStorage: "Kopia i block storage",
      trBlockStorageNone: "ingen ännu — den första kommer efter den första checkpointen",
      trUploading: "laddar upp: steg {step}",
      treeCkRun: "Träningskörning",
      treeCkCopy: "Checkpoint i block storage, kopierad {time}",
      treeCkLocal: "Checkpoint på serverns disk",
      treeCkUploading: "kopieras just nu till block storage",
      trKpiProgress: "Förlopp",
      trKpiTokens: "Tokens",
      trKpiThroughput: "Genomströmning",
      trKpiLoss: "Loss",
      trKpiLr: "Inlärningstakt",
      trKpiGpu: "GPU-minne",
      trEndAt: "slut ca {time}",
      trSeenPlanned: "sedda / planerade",
      trBest: "bästa {value}",
      trHourAgo: "{value} jämfört med för 1 h sedan",
      trPerplexity: "perplexitet {value}",
      trPhaseWarmup: "uppvärmning",
      trPhaseCosine: "cosinusavtagande",
      trPhaseStable: "stabil fas",
      trPhaseDecay: "nedkylning",
      trKpiEpoch: "Epok",
      trEpochValue: "{epoch} av {epochs}",
      trPlanTitle: "Körplan",
      trPlanExplain: "Uppvärmning till den högsta inlärningstakten, sedan konstant över fyra blandade epoker av korpusen; nedkylningsfasen tränar på den mest högkvalitativa blandningen (förmågeexempel, läroplanstexter, anneal) och sänker inlärningstakten till noll.",
      trPlanPhase: "Fas",
      trPlanStableSteps: "Planerade steg i den stabila fasen",
      trPlanDecay: "Nedkylning",
      trPlanDecayAhead: "från steg {step} · om cirka {time}",
      trPlanDecayAheadNoTime: "från steg {step}",
      trPlanDecayRunning: "sedan steg {step} · {steps} steg till inlärningstakt noll",
      trPlanTokensPerStep: "Tokens per optimeringssteg",
      trPlanTokensPerStepValue: "{tokens} ({accum} mikrobatcher)",
      trPlanRecompute: "Omräkning av aktiveringar",
      trPlanRecomputeOn: "på – uppmätt snabbare med större mikrobatch",
      trPlanRecomputeOff: "av – uppmätt snabbare utan",
      trPlanFim: "Dokument i fill-in-the-middle-form hittills",
      tbTitle: "Läroboksprogram",
      tbSubtitle: "Foundationtexter omskrivna av lärarmodeller som lärobokstext; varje tal och varje egennamn måste finnas i källan.",
      tbTokens: "Lärobokstokens",
      tbTokensSub: "{pct} % av målet {target}",
      tbSamples: "Godkända omskrivningar",
      tbJobs: "Avslutade jobb",
      tbTeacher: "Lärartokens per lärobokstoken",
      tbCost: "Kostnad per miljon lärobokstokens",
      tbCostNone: "gatewayen rapporterar ingen kostnad; lärartokens räknas",
      tbExplain: "Löper bredvid träningen; senare epoker och nedkylningen läser det som är förseglat till dess.",
      trThroughputTitle: "Genomströmning (tokens/s)",
      trCurriculumTitle: "Läroplan",
      trStageTokens: "{tokens} tokens",
      trStageBegins: "börjar vid steg {step}",
      trPlanWarningLabel: "Observera",
      trPlanWarning: "Körningen slutar efter {max} steg i steget ”{stage}” — förmågedatan börjar först vid steg {cap}. En full genomgång skulle kräva {steps} steg (≈ {days} dagar).",
      trPlanOk: "De planerade stegen når steget ”{stage}”.",
      trCheckpointsTitle: "Checkpoints",
      trNextCheckpoint: "Nästa checkpoint",
      trInSpan: "om {span}",
      trResumes: "Återupptagning",
      trNoResume: "ingen",
      trConfig: "Konfiguration",
      trHealth: "Tillstånd",
      trMicroBatch: "Mikrobatch / tokens per steg",
      trSeqLen: "Sekvenslängd",
      trLrPlan: "Inlärningstaktsplan",
      trLrPlanValue: "topp {lr}, uppvärmning {warmup} steg, cosinus till steg {max}",
      trSpikes: "Loss-toppar (senaste timmen)",
      trProgressSub: "steg {step} av {max} · tränar sedan {elapsed}",
      trTokensSub: "av {planned} planerade",
      trPathTrainingDetail: "{pct} % · steg {step} av {max} · slut ca {end}",
      trReadinessRunning: "Träningen pågår: {pct} % klart (steg {step} av {max}), loss {loss}, slut ca {end}.",
      tdvDraftsHistory: "Äldre utkast, aldrig förseglade ({count})",
      runsHistory: "Avbrutna och misslyckade körningar ({count})",
      trAxisStep: "Träningssteg",
      trAxisLoss: "Loss (naturlig logaritm)",
      trCountdown: "{d} d {h} h {m} min {s} s",
      trTimerWaiting: "Timern kommer efter de första mätpunkterna.",
      trTimerStageEnds: "Steget ”{stage}” slutar om",
      trTimerAt: "kl. {time}",
      trTimerNext: "Därefter ”{stage}”: {span}, från {time}",
      trTimerRunEnds: "Körningen slutar om {span} (kl. {time})",
      trStepTimeSub: "{wall} s per steg uppmätt · beräkning {compute} s",
      trEtaTitle: "Återstående tid från den uppmätta stegtiden",
      trEtaEpochEnds: "Epok {epoch} av {epochs} slutar om",
      trEtaEpochAt: "kl. {time} (steg {step})",
      trEtaNextEpoch: "Epok {epoch}: från {time} (steg {step})",
      trEtaDecay: "Nedkylningsfasen börjar om {span} (kl. {time}, steg {step})",
      trEtaBasis: "Grund: {wall} s per steg, medel av de senaste {n} stegen utan {pauses} pauser (omstart, stillestånd); beräkningstid enligt tränaren {compute} s per steg.",
      devTitle: "Avvikelser från ritningen",
      devNone: "Inga avvikelser — körningen följer ritningen helt.",
      devPlanned: "planerat",
      devLimit: "begränsning",
      devSeqLen: "Kontextlängd",
      devSeqLenText: "Tränar med {trained} tokens kontext i stället för ritningens {spec}. Den långa kontexten kommer i en senare fas.",
      devFim: "Luckfyllning (FIM)",
      devFimText: "Luckfyllningsmålet ({rate} % av blocken) är deklarerat i ritningen men ännu inte aktivt i denna körning.",
      devTermination: "Avslutssond",
      devTerminationText: "Avslutssonden är inget träningsmål utan ett eget läge efter träningen; den körs senare över en färdig checkpoint.",
      devDecision: "Beslutsmål",
      devDecisionText: "Beslutsmålet är aktivt, men inga beslutsmarkeringar kom in i den här körningens efterträningssteg.",
      devKernelOff: "Acceleration av",
      devKernelUnverifiedText: "Kärnan ”{kernel}” bekräftades inte av sonden och körs som standardberäkning.",
      devKernelUnavailableText: "Kärnan ”{kernel}” finns inte på detta kort och körs som standardberäkning.",
      devKernelFellBackText: "Kärnan ”{kernel}” föll under körningen tillbaka till standardberäkning ({reason}).",
      devOptimizer: "Optimerare",
      devOptimizerText: "Optimerarens tillstånd ligger i bfloat16 i stället för 8 bitar (bitsandbytes saknas) — mer minne, samma matematik.",
      devScale: "Modellstorlek",
      devScaleText: "Modellen är instansierad till {scale} % av ritningens storlek eftersom full storlek inte rymdes i det uppmätta minnet.",
      devMediaHeads: "Mediehuvuden",
      devMediaHeadsText: "Bild-/ljudhuvudena är otränade eftersom träningsdatan saknar medietokens — planerat för en textsträng.",
      devVision: "Bildväg",
      devVisionText: "Bildvägen är byggd men tränade på noll bilder eftersom datan saknar sådana.",
      devOther: "Övrigt",
      trStageShare: "{pct} % av detta steg klart",
      cap_tool_calling: "Verktygsanrop",
      cap_deep_reasoning: "Djupt resonemang",
      cap_software_engineering: "Programvaruutveckling",
      cap_office_finance: "Kontor & ekonomi",
      cap_doc_understanding: "Dokumentförståelse",
      tpExplainThresholds: "För varje förmåga i den valda strängen måste tillräckligt många granskade träningsexempel finnas i data laken. Mål och mätvärde står här per förmåga.",
      tpThresholdsDetail: "{met} av {total} förmågor har nått sitt mål",
      tpThresholdRow: "{measured} exempel",
      tpForeignThresholds: "Inte för denna sträng: {list} — tillhör en annan sträng och blockerar inget.",
      tpStepTokenizerReleaseExplain: "Tokeniseraren gör text till tal. Den fastställs en gång och rapporteras till arkitekturen så att data och modell talar samma språk.",
      tpStepTokenizeTdvExplain: "Alla granskade träningsexempel översätts till talföljder med den fastställda tokeniseraren.",
      tpStepTokenizeCorpusExplain: "All råtext i data laken översätts till talföljder — massan för grunden.",
      tpStepTdvCreateExplain: "Av all tokeniserad data sätts en fast träningsdataversion (TDV) samman, med läroplan och uppmätt tokenmängd.",
      tpStepTdvSealExplain: "Versionen görs oföränderlig och kopieras med beskrivning till block storage.",
      tpStepCompatExplain: "Tolv regler kontrollerar att version och arkitektur passar ihop (tokeniserare, kontextlängd, mål, minne). Alla måste vara gröna.",
      tpStepVramExplain: "Mäter på kortet om tillräckligt GPU-minne är ledigt för det deklarerade behovet.",
      tpVramDetail: "{free} GB lediga, {need} GB behövs",
      tpStepTrainStartExplain: "Autopiloten startar träningskörningen så snart alla förutsättningar är uppfyllda.",
      tpStepTrainingExplain: "Körningen tränar på egen hand med checkpoints var 30:e minut och fortsätter själv efter varje avbrott. Detaljer på sidan ”Träning & publicering”.",
      tpVramRunning: "kortet används av den pågående träningen ({need} GB behövs); uppfyllt vid starten",
      trPathTrainingDetailNoEnd: "{pct} % · steg {step} av {max}",
      srTitle: "Databeredskap per modellsträng",
      srSubtitle: "Medan en sträng tränar fortsätter data laken att förbereda de andras data — fram till deras egen förseglade version, utan träningsstart.",
      srTrainingNow: "tränar nu",
      srSelected: "vald",
      srDataReady: "data klara",
      srPreparing: "förbereds",
      srModalities: "indata: {in} · utdata: {out}",
      srThresholds: "mål: {met} av {total} nådda",
      srCorpus: "Tokeniserad korpus",
      srCorpusValue: "{tokens} tokens i {shards} datapaket",
      srVersion: "Senaste version",
      srNoVersion: "ingen ännu",
      srLacking: "Saknas ännu",
      srLacksNothing: "inget — versionen väntar på sin sträng",
      srLackThresholds: "mål ej nådda",
      srLackCodec: "bild-/ljudkodek ej släppt",
      srLackTokenizer: "tokeniserare ej rapporterad",
      srLackVersion: "ingen förseglad version",
      srSelectedNote: "Den här strängen tränar nu; dess väg står ovan.",
      srSelectedIdleNote: "Den här strängen är vald för nästa träning; dess väg står ovan.",
      srUnselectedNote: "Den här strängen startar ingen träning medan en annan är vald — dess data förbereds ändå fullt ut.",
      modText: "text",
      modImage: "bild",
      modAudio: "ljud",
      modVideo: "video",
      tpStepThresholds: "Nå målen",
      tpStepPlan: "Nå artikelns dataplan",
      tpExplainPlan: "Artikeln anger hur många unika, granskade token varje område behöver. Tyska och engelska bär var för sig minst hälften; kod räknas utan språk. Räknade är de godkända token efter att dubbletter tagits bort, inte råuppskattningen.",
      tpPlanDetail: "{met} av {total} områden nådda",
      tpPlanRowLang: "{have} / {target} · tyska {de} / {half} · engelska {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "öppet: {langs}",
      tpLangDe: "tyska",
      tpLangEn: "engelska",
      tpPlanProvisional: "Preliminärt räknat med den tidigare tokeniseraren; avgörande är den nytränade.",
      tpStepOwnTokenizer: "Strängens egen tokeniserare",
      tpStepOwnTokenizerExplain: "Strängen tränas med en egen tokeniserare, inlärd på en balanserad korpus som innehåller kod. Först i dess token räknas dataplanen slutgiltigt.",
      tpPlanCat_knowledge: "Kunskap",
      tpPlanCat_code: "Kod",
      tpPlanCat_mathematics: "Matematik",
      tpPlanCat_domain: "Facktexter",
      tpPlanCat_textbook: "Lärobok",
      tpPlanCat_agentic: "Agentiska exempel",
      tpPlanFlow: "inflöde {rate} per timme",
      tpPlanEtaDays: "ungefär {n} dagar kvar",
      tpPlanEtaHours: "ungefär {n} timmar kvar",
      tpPlanNoFlow: "inget inflöde de senaste 24 timmarna",
      tpPlanBinding: "flaskhals",
      tpBind_download: "nedladdning",
      tpBind_allowance: "block storagens dagliga kvot",
      tpBind_ingest: "inläsning",
      tpBind_teachers: "lärarmodeller",
      thrPlanTitle: "Exempel per förmåga (uppmätt)",
      thrPlanNote: "Strängens mål fastställs av dess artikel: dataplanen per område, på tyska och engelska, på vägen till träningsstarten. Trösklar per förmåga gäller bara för strängar utan dataplan; här står vad varje förmåga innehåller enligt mätningen.",
      thrPlanRow: "{samples} exempel · {tokens} token",
      srDataPlan: "Artikelns dataplan: {met} av {total} områden nådda",
      srLackDataPlan: "dataplanen inte nådd",
      srPlanOpen: "öppet: {areas}",
      tpBind_source: "ingen källa på detta språk",
      tpBind_paused: "nedladdning pausad",
      tdvPlanEmpty: "Ännu ingen dataversion av den aktiva specifikationen. Autopiloten bygger och förseglar den när artikelns dataplan är nådd.",
      compatPlanNone: "Ingen kontroll ännu: den aktiva specifikationens dataversion kontrolleras när den förseglas.",
      mixPlanTitle: "Blandning enligt artikeln",
      mixPlanNote: "Varje träningssteg hämtar områdena i dessa fasta andelar; avklingningsfasen höjer den högkvalitativa andelen upp till hälften. Blandningsmål per förmåga gäller bara för strängar utan dataplan.",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "Läge",
      sitSubtitle: "Var träningen står med en blick: vad varje område i artikeln fortfarande saknar, vad som körs nu och vad som kommer sedan.",
      sitHeadlineDays: "Träningen kan starta tidigast om ungefär {time}; längst tid tar {area} (flaskhals: {bottleneck}).",
      sitHeadlineBlocked: "Så nås inte dataplanen: {items} saknar källa. Arbete pågår: söka öppna dataset eller översätta med kontroll.",
      sitHeadlineReached: "Dataplanen är nådd; därefter tokeniseraren, ny tokenisering, försegling och kontroller.",
      sitHeadlineUnknown: "Inflödet för resten är ännu inte uppmätt.",
      sitHold: "Starten är dessutom stoppad tills varje byggsten är kontrollerad.",
      sitArea: "Område",
      sitTotal: "Totalt",
      sitFlow: "Inflöde",
      sitLeft: "Kvar",
      sitBottleneck: "Flaskhals",
      sitNoLanguage: "utan språk",
      sitNoSource: "ingen källa",
      sitReached: "nådd",
      sitDays: "{n} dagar",
      sitHours: "{n} tim",
      sitPerHour: "{value} per timme",
      sitPerHourTokens: "{value} token per timme",
      sitRunningTitle: "Vad som körs nu",
      sitDownloads: "Nedladdningar",
      sitIngest: "Bearbetning till textavsnitt",
      sitTokenize: "Tokenisering",
      sitGenerate: "Generering av lärarmodeller",
      sitIdle: "vilar",
      sitNextTitle: "Vad som kommer sedan",
      sitNextSteps: "Träna tokeniseraren med kod → tokenisera hela korpusen på nytt → försegla versionen → kontroller → träningsstart",
      sitProvisional: "Mängderna räknas preliminärt med den tidigare tokeniseraren; slutgiltigt räknar den nytränade.",
      tpPlanSeeSituation: "Områden, språk och återstående tider står i lägesbilden ovan.",
      sitHeadlineBlocks: "Träningen kan inte starta än: byggstenar saknas som först måste byggas ({items}). Under tiden växer datan.",
      sitDuration: "Träningens längd: ungefär {days} dagar för {budget} token vid uppmätta {rate} token per sekund på samma nät.",
      sitBlocksTitle: "Träningens byggstenar",
      sitStateNotBuilt: "ännu inte byggd",
      sitStateWaiting: "väntar",
      sitStateReady: "klar",
      sitBlockWaitsFor: "väntar på: {items}",
      sitBenchProgress: "{made} av {total} verifierade uppgifter",
      sitBlockParts: "byggt: {built} · öppet: {open}",
      part_graph_bundles: "länkade dokument",
      part_repository_bundles: "hela kodförråd",
      part_long_context: "lång kontext",
      part_fine_tuning: "finjustering",
      part_reinforcement_learning: "förstärkningsinlärning",
      part_real_folding: "verklig kontextvikning",
      sitBlock_data: "Data enligt artikelns plan",
      sitBlock_tokenizer: "Tokeniserare med kod",
      sitBlock_bench: "Artikelns benchmarksvit",
      sitBlock_trainer: "Tränare: fönstersteg, fast budget, fast blandning",
      sitBlock_bundles: "Paket: länkade dokument och hela repositorier",
      sitBlock_post_training: "Efterträning: lång kontext, finjustering, belöningsinlärning",
      tpStepTokenizerRelease: "Tokenizer-släpp",
      tpStepTokenizeTdv: "Tokenisera träningsexemplen",
      tpStepTokenizeCorpus: "Tokenisera korpusen",
      tpStepTdvCreate: "Skapa dataversionen",
      tpStepTdvSeal: "Försegla dataversionen",
      apAfterSealLabel: "Fortsätt automatiskt efter förseglingen",
      apAfterSealOn: "PÅ",
      apAfterSealOff: "AV",
      apAfterSealConfirmOn: "Fortsätta automatiskt efter förseglingen? Vägen till träningsstarten går då vidare utan paus: kompatibilitetskontroll, GPU-kontroller och träningsstart.",
      apAfterSealConfirmOff: "Stanna igen efter förseglingen? Autopiloten pausar då för granskning när dataversionen är förseglad.",
      apAfterSealTurnedOn: "Vägen till träningsstarten fortsätter automatiskt efter förseglingen.",
      apAfterSealTurnedOff: "Autopiloten stannar efter förseglingen.",
      apAfterSealWaiting: "Dataversionen är förseglad – autopiloten pausar för granskning.",
      apAfterSealStep: "Granskning av den förseglade dataversionen",
      apAfterSealHint: "Efter förseglingen ligger all data bearbetad i blocklagringen. Med brytaren av pausar autopiloten där för granskning; på fortsätter vägen automatiskt.",
      tpStepCompat: "Kompatibilitetskontroll",
      tpStepVram: "VRAM-test",
      tpStepTrainStart: "Träningsstart",
      tpStepTraining: "Träning pågår",
      apSubtitle: "En brytare för hela kretsloppet: samla, bearbeta och länka data, generera exempel, träna när artikelns dataplan är nådd, benchmarka och publicera privat. Varje blockering namnges i stället för att döljas.",
      apOn: "Autopilot PÅ",
      apOff: "Autopilot AV",
      apTurnOn: "Slå på autopiloten",
      apTurnOff: "Stäng av autopiloten",
      apConfirmOn: "Slå på autopiloten? Den fyller på datan löpande fram till den förseglade dataversionen; därefter pausar den för granskning, om inte ”Fortsätt automatiskt efter förseglingen” är på.",
      apConfirmOff: "Stänga av autopiloten? Pågående arbete avslutas kontrollerat; inget kastas.",
      apEnabled: "Autopiloten påslagen",
      apDisabled: "Autopiloten avstängd",
      apPause: "Pausa",
      apResume: "Återuppta",
      apResumed: "Autopiloten återupptagen",
      apPausedNote: "Autopiloten pausad",
      apPausedPill: "pausad",
      apPhaseLabel: "Fas",
      apPhaseSince: "sedan {time}",
      apCycleId: "Cykel",
      apBlockedLabel: "Blockerad",
      apCycleTitle: "Den pågående cykelns förlopp",
      apCycleEmpty: "Ingen cykel aktiv.",
      colPhase: "Fas",
      colPending: "Väntar",
      colRunning: "Pågår",
      colDone: "Klart",
      colFailed: "Misslyckat",
      thrTitle: "Trösklar per förmåga",
      thrSubtitle: "Från dessa volymer förseglar autopiloten en träningsdataversion och startar träningen; staplarna visar det uppmätta förloppet.",
      thrMet: "uppnådd",
      thrNotMet: "öppen",
      thrDefault: "förifylld standard",
      thrForeign: 'inte för den valda grenen',
      staleSince: 'Arbetaren svarar inte just nu — senast uppmätta läge från',
      staleHint: 'Autopiloten fortsätter; vyn uppdateras så snart arbetaren svarar igen.',
      idxTitle: 'Vektorindex och deduplicering',
      idxSubtitle: 'Sjöns eget HNSW-index för graflänkning och den uppmätta borttagningen av dubblerade chunk-shards.',
      idxConfigured: 'Index konfigurerat',
      idxReachable: 'Index nåbart',
      idxPoints: 'Indexpunkter',
      idxBackfill: 'Påfyllning från embeddings-tabellen',
      idxBackfillDone: 'klar',
      idxBackfillOpen: 'pågår / öppen',
      ddLastPass: 'Senaste dedup-körning',
      ddChecked: 'kontrollerade tillgångar',
      ddDropped: 'borttagna dubblerade shards',
      ddRows: 'borttagna chunk-rader',
      ddRemaining: 'återstående kandidater',
      ddNone: 'ingen körning ännu',
      gsTitle: 'Grafsteg',
      gsSubtitle: 'Grafens teacher-steg — embedding och utvinning av påståenden — tjänar den grafhärledda exempelsyntesen; därför tar de chunks på bredden över tillgångarna i rangordning: rang 0 ägarens dokument och verktygsimporter, rang 1 expertkunskap (vetenskap, teknik, böcker, resonemang, German Commons, Wikipedia), rang 2 allmän text (Wikisource, Gutenberg, webbkorpusar, transkript), rang 3 kod (endast inbäddad, aldrig påståendeutvinning). Grundmassan når tokenkorpusen utan teacher-pass.',
      gsMeasuredAt: 'Uppmätt kl.',
      gsRanksTitle: 'Rangordning',
      gsRanksEmpty: 'Ingen rangplan rapporterad ännu.',
      gsColRank: 'Rang',
      gsColLabel: 'Källklass',
      gsColSources: 'Källor',
      gsColAssets: 'Tillgångar',
      gsColPendingExtract: 'Väntande utvinning',
      gsColPendingEmbed: 'Väntande embedding',
      gsRankOwner: 'Ägarens dokument och verktygsimporter',
      gsRankExpert: 'Expertkunskap',
      gsRankGeneral: 'Allmän text',
      gsRankCode: 'Kod (endast embedding)',
      gsRankShort: 'rang {n}',
      gsLoopsTitle: 'Senaste varvet i varje loop',
      gsColLoop: 'Loop',
      gsColSource: 'Källa',
      gsColChunks: 'Chunks klara',
      gsColClaims: 'Påståenden',
      gsColEdges: 'Kanter',
      gsColSeconds: 'Sekunder',
      gsColLast: 'Senaste varv',
      gsLoopEmbed: 'Embedding',
      gsLoopExtract: 'Utvinning av påståenden',
      gsLoopLink: 'Länkning',
      gsUngrounded: '{n} utan belägg',
      gsNoRound: 'inget varv ännu',
      gsClaims: 'Påståenden totalt',
      gsAssetsWithClaims: 'Tillgångar med påståenden',
      gsDangling: 'Föräldralösa chunk-noder',
      gsStuck: 'Fastnade tillgångar (under bearbetning utan pågående ingest)',
      gsConcurrency: 'Parallellitet i utvinningen',
      gsOrphansLast: 'Senaste rensningskörning',
      gsOrphansNone: 'ingen körning ännu',
      gsOrphansStatusCleaned: 'rensat',
      gsOrphansDropped: 'noder borttagna',
      gsOrphansRemaining: 'återstår',
      gsOrphansHint: 'Inget att göra här: autopiloten planerar själv en begränsad rensningskörning så länge det finns chunk-noder utan shard. Sammanfattningen visar den senaste körningen.',
      thrSamplesBar: "Exempel",
      thrTokensBar: "Tokens (uppskattade)",
      thrNoMinimum: "uppmätt, inget minimum",
      thrEditTitle: "Redigera trösklar",
      thrEditSubtitle: "Att spara ersätter alla trösklar helt; förifyllda standarder gäller bara tills egna värden satts här.",
      thrMinSamples: "Min. exempel",
      thrMinTokens: "Min. tokens (uppskattade)",
      thrEnabled: "aktiv",
      thrAdd: "Lägg till rad",
      thrSave: "Spara trösklar",
      thrSaved: "Trösklar sparade",
      thrEmpty: "Inga trösklar definierade ännu — utan aktiva trösklar förseglar autopiloten ingenting och rapporterar det som en blockering.",
      capability: "Förmåga",
      modSignature: "Signatur",
      removeRow: "Ta bort",
      budgetsTitle: "Dagsbudgetar",
      budgetsSubtitle: "Förbrukning mot tak per område och dag — budgetarna begränsar lärar- och embeddinganrop.",
      budgetScope: "Område",
      budgetDay: "Dag",
      budgetSpent: "Förbrukat",
      budgetCap: "Tak",
      budgetsEmpty: "Inga budgetar rapporterade.",
      eventsTitle: "Händelser",
      eventsSubtitle: "Vad autopiloten senast gjorde eller rapporterade, nyast först.",
      eventsEmpty: "Inga händelser ännu.",
      storageTitle: "Molnlagring",
      storageSubtitle: "Anslutningen till Block Storage och initieringen av mappstrukturen — upprepningsbar utan sidoeffekter.",
      connect: "Anslut Block Storage",
      backendLabel: "Kallagrets backend",
      backendBlockStorage: "Block Storage",
      backendLocal: "Lokal lagring",
      connectedLabel: "Anslutning",
      connectedYes: "ansluten",
      connectedNo: "inte ansluten",
      accountLabel: "Konto",
      signinValidUntil: "Inloggning giltig till",
      oauthClientLabel: "OAuth-klient",
      clientConfigured: "konfigurerad",
      clientNotConfigured: "inte konfigurerad",
      bootstrapRun: "Initiera struktur",
      bootstrapDone: "Initiering utförd",
      bootstrapReportTitle: "Senaste körning",
      bootstrapNoRun: "Ingen bootstrap har körts i den här sessionen ännu.",
      bootstrapLine: "Skapade mappar: {folders} · filer i kallagret: {files} · upprepning utan ändringar: {idempotent}",
      treeTitle: "Mappträd",
      treeSubtitle: "Trädet är en versionerad specifikation: här definierar du mappar, autopiloten får bara lägga till. Skyddade motormappar och icke-tomma mappar avvisas av motorn med motivering. I Block Storage raderas bara enligt fasta regler, till exempel äldre checkpointkopior (de två nyaste stannar); under en fullständig nedladdning väntar raderingar och överskrivningar tills den är klar.",
      treeActiveVersion: "Aktiv version v{version}",
      treePath: "Sökväg",
      treePurpose: "Syfte",
      treeCreatedBy: "Skapad av",
      treeShards: "Shards",
      treeBytes: "Storlek",
      treeActions: "Åtgärder",
      treeRetire: "Ta ur bruk",
      treeRetired: "Mapp tagen ur bruk",
      treeAddFolder: "Lägg till mapp",
      treeFolderAdded: "Mapp skapad",
      treeVersionsTitle: "Versioner",
      treeEmpty: "Inga mappar definierade ännu.",
      treePlanned: "Planerat — trädspecifikation v{version}",
      treeFiles: "Filer",
      treeSizesMeasured: "Storlekar uppmätta {measured}; mapparna som katalogen inte för räknades senast i Block Storage {walked}. 1 GB = 10⁹ byte.",
      treeSizesNoWalk: "Storlekar uppmätta {measured}; mapparna som katalogen inte för har ännu inte räknats. 1 GB = 10⁹ byte.",
      treeExpand: "Visa {count} undermappar",
      treeCollapse: "Dölj undermappar",
      treeShowMore: "Visa {count} mappar till",
      treeSourceCatalog: "Från katalogen: räknade är objekt som verkligen ligger i Block Storage",
      treeSourceWalk: "Räknat vid genomgången av Block Storage",
      bsUsageTitle: "Utrymme i Block Storage",
      bsUsageSubtitle: "Använt utrymme, gräns och ledigt utrymme i Block Storage-kontot och data lakens andel av det; värdena är högst tio minuter gamla. 1 GB = 10⁹ byte.",
      bsUsed: "Använt",
      bsLimit: "Gräns",
      bsFree: "Ledigt",
      bsNoLimit: "utan fast gräns",
      bsTrash: "I papperskorgen",
      bsLake: "Varav data lake",
      bsLakeLine: "{size} i {files} filer · {share} av det använda utrymmet",
      bsMeasuredAt: "Uppmätt",
      bsNotConnected: "Block Storage är inte anslutet; utrymmet visas så snart anslutningen finns.",
      bsBarLake: "Data lake",
      bsBarOther: "Övrigt i kontot",
      bsDlTitle: "Fullständig nedladdning",
      bsDlSubtitle: "Laddar ner hela Block Storage fil för fil i samma mappstruktur, utan arkiv. Medan den pågår gäller skyddsläget: raderingar och överskrivningar av de registrerade filerna väntar tills den är klar; nya filer skrivs vidare och hör inte till den här nedladdningen. En pågående träning hålls aldrig upp.",
      bsDlButton: "Ladda ner hela Block Storage",
      bsDlFolderHint: "Du väljer en målmapp en gång; undermapparna skapas där. Filer som redan är kompletta hoppas över, avbrutna fortsätter från sin längd.",
      bsDlScriptHint: "Den här webbläsaren kan inte skriva mappar. Du får ett nedladdningsskript som skapar samma mappstruktur och hämtar varje fil så att den kan återupptas.",
      bsDlWindowsNames: "Tecken som Windows inte tillåter i namn (till exempel ”>”) står i målmappen som %-kod, till exempel %3E.",
      bsDlActiveNote: "En nedladdning pågår sedan {time}. Knappen ovan fortsätter den i den här webbläsaren; kompletta filer hoppas över.",
      bsDlBuilding: "Fillistan skapas: hittills {files} filer, {size}.",
      bsDlManifest: "Fillistan laddas: {done} av {total} poster.",
      bsDlFolder: "Målmapp",
      bsDlFiles: "Filer",
      bsDlData: "Data",
      bsDlOf: "{done} av {total}",
      bsDlRate: "Hastighet",
      bsDlEta: "Återstående tid",
      bsDlEtaUnknown: "beräknas",
      bsDlCurrent: "Laddas just nu",
      bsDlSkipped: "{count} redan kompletta, överhoppade",
      bsDlFailed: "{count} filer misslyckades",
      bsDlPausedNote: "Pausad. Påbörjade filer fortsätter från sin längd när du återupptar; skyddsläget kvarstår så länge den här sidan är öppen.",
      bsDlPause: "Pausa",
      bsDlContinue: "Fortsätt",
      bsDlRetryFailed: "Ladda misslyckade igen",
      bsDlFinish: "Slutför",
      bsDlStop: "Stoppa",
      bsDlStateBuilding: "fillistan förbereds",
      bsDlStateRunning: "laddar ner",
      bsDlStatePaused: "pausad",
      bsDlStateIncomplete: "ofullständig",
      bsDlStateScript: "skript klart",
      bsDlStateFinished: "slutförd",
      bsDlStateStopped: "avslutad",
      bsDlStateActive: "aktiv",
      bsDlFinished: "Alla {files} filer ({size}) ligger i målmappen; nedladdningen är slutförd.",
      bsDlFinishedNote: "Nedladdningen är slutförd; de tillbakahållna raderingarna och överskrivningarna körs nu.",
      bsDlStopped: "Nedladdningen är stoppad; de tillbakahållna raderingarna och överskrivningarna körs nu. Redan nedladdade filer finns kvar.",
      bsDlEnded: "Servern avslutade nedladdningen, till exempel efter trettio minuter utan livstecken. Ett nytt klick startar den igen; kompletta filer hoppas över.",
      bsDlSession: "Inloggningen har gått ut. Logga in igen; därefter fortsätter knappen ovan nedladdningen.",
      bsDlDiskFull: "Målmappen har inget utrymme kvar. Frigör utrymme och fortsätt sedan.",
      bsDlPickFailed: "Målmappen kunde inte öppnas.",
      bsDlScriptPosix: "Skript för Linux och macOS",
      bsDlScriptWindows: "Skript för Windows",
      bsDlScriptRun: "Spara skriptet i målmappen och starta det där: på Windows genom att dubbelklicka på .cmd-filen eller från kommandotolken, på Linux och macOS i en terminal med ”sh <fil>”.",
      bsDlScriptKeyValid: "Nyckeln i skriptet gäller till {time}, bara för den här nedladdningen och bara för läsning.",
      bsDlScriptHeartbeat: "Så länge den här sidan är öppen meddelar den servern att nedladdningen fortfarande pågår. Klicka på ”Slutför” när skriptet är klart.",
      bsDlProtection: "Skyddsläge",
      bsDlProtectionState: "Tillstånd",
      bsDlProtectionOn: "aktivt sedan {time}",
      bsDlProtectionOff: "inte aktivt",
      bsDlScope: "Nedladdningens omfattning",
      bsDlScopeValue: "{files} filer, {size}",
      bsDlDeferredDeletes: "Tillbakahållna raderingar",
      bsDlDeferredOverwrites: "Tillbakahållna överskrivningar",
      bsDlAddedSince: "Tillagda sedan starten",
      bsDlLastActivity: "Senaste livstecken",
      acqTitle: "Datakällor",
      acqSubtitle: "Kurerade källor med öppen licens: per källa licens, dataskyddsbedömning, språk, modalitet, bytemål och uppmätt förlopp. Avstängda källor namnger sin orsak i stället för att saknas i tysthet.",
      acqGdprNote: "GDPR-princip: träningsdata släpps bara in från källor med öppen licens och dokumenterad dataskyddsbedömning; inkorgsdata passerar en PII-rensning innan exempel byggs (räknaren \"PII-rensade\" visar det).",
      acqSource: "Källa",
      acqModality: "Modalitet · språk",
      acqLicense: "Licens",
      acqProtection: "Dataskydd",
      acqProgress: "Förlopp",
      acqDocs: "{count} filer/objekt mottagna",
      acqTargetReached: "mål uppnått",
      acqExhausted: "källan uttömd (listningen levererar inget mer)",
      acqEnabledPill: "aktiv",
      acqWaitingBuffer: "väntar: bufferten full, uppladdningen hinner ikapp",
      acqDisabledPill: "avstängd",
      acqEnable: "Aktivera",
      acqDisable: "Stäng av",
      acqEnabledMsg: "Källa aktiverad",
      acqDisabledMsg: "Källa avstängd",
      acqTargetLabel: "Mål (GB)",
      acqSetTarget: "Spara mål",
      acqTargetSaved: "Mål sparat",
      acqEmpty: "Inga källor registrerade ännu.",
      balanceTitle: "Språkbalans tyska/engelska",
      balanceSubtitle: "Nedladdade byte per modalitet och språk — för frökällorna får tyskan inte hamna efter engelskan.",
      balanceEmpty: "Inga mätvärden ännu.",
      modText: "Text",
      modAudio: "Ljud",
      modImage: "Bild",
      modVideo: "Video",
      prepTitle: "Förbearbetning",
      prepSubtitle: "Räknade pipelinesteg från registrerat rådokument till träningsexempel — varje siffra ur katalogen; fel och sådant som inte stöds namnges.",
      prepRegistered: "registrerade",
      prepScrubbed: "PII-rensade",
      prepChunked: "uppdelade",
      prepEmbedded: "inbäddade",
      prepExtracted: "extraherade",
      prepLinked: "länkade",
      prepSamples: "exempel",
      prepByLang: "Per språk",
      prepUnsupported: "Stöds ej",
      prepAwaiting: "Väntar på ett steg",
      prepFailures: "Fel",
      inboxTitle: "Rådatainkorg",
      assetWhat: "Innehåll",
      assetFromSource: "från källan {source}",
      assetFromUpload: "uppladdad manuellt",
      mediaParquet: "Tabelldata (Parquet)",
      treeShardsHint: "Shards är katalogens Parquet-datapaket: varje rad är ett paket med ursprung, språk och syfte — kolumnen ”syfte” säger vad som finns i en mapp.",
      mediaWords: {
        text: "Text",
        audio: "Ljud",
        video: "Video",
        image: "Bild",
        application: "Fil",
      },
      inboxSubtitle: "Ge egna rådata till laken: ladda upp här eller lägg dem direkt i molnmappen raw/inbox/. Avstämningen registrerar varje fil; \"Bearbeta nu\" startar samma väg som autopiloten går på egen hand.",
      uploadButton: "Ladda upp fil",
      uploadHint: "Upp till 512 MB per fil. Uppladdningar hamnar i kallagret och delas vid bearbetning upp, bäddas in och länkas in i kunskapsgrafen.",
      uploadTooLarge: "Filen är större än 512 MB.",
      uploadDone: "Fil mottagen",
      processNow: "Bearbeta nu",
      processStarted: "Bearbetning startad",
      reconcileNow: "Stäm av molnmapp",
      reconcileDone: "Avstämning utförd",
      unprocessedCount: "{count} obearbetade",
      inboxEmpty: "Inkorgen är tom.",
      assetName: "Fil",
      assetType: "Typ",
      assetSize: "Storlek",
      assetState: "Tillstånd",
      assetLang: "Språk",
      assetRegistered: "Registrerad",
      assetStates: {
        raw_stored: "rådata sparad",
        awaiting_stt: "väntar på taligenkänning",
        awaiting_content_fetch: "väntar på innehållet bakom adressen",
        awaiting_image_codec: "väntar på bildcodecen",
        awaiting_audio_codec: "väntar på ljudcodecen",
        awaiting_video_codec: "väntar på videocodecen",
        chunked: "uppdelad & i grafen",
        processed: "bearbetad",
        registered: "registrerad",
        queued: "väntar",
        processing: "bearbetas",
        ingested: "intagen",
        linked: "länkad",
        unsupported: "stöds ej",
        failed: "misslyckad",
      },
      graphTitle: "Kunskapsgraf",
      graphSubtitle: "Det länkade råbeståndet: noder och kanter räknade ur katalogen — ur dessa kopplingar uppstår träningsexemplen.",
      graphEmbedded: "Inbäddade noder",
      graphModel: "Embeddingmodell",
      graphClusters: "Kluster",
      graphAssetsLinked: "Länkade rådata",
      graphLastLink: "Senaste länkning",
      graphNodesTitle: "Noder per slag",
      graphEdgesTitle: "Kanter per slag",
      graphEmpty: "Grafen är ännu tom — den uppstår med den första bearbetade filen.",
      kindCol: "Slag",
      countCol: "Antal",
      neighborsTitle: "En nods grannar",
      nodeIdLabel: "Nod-ID",
      neighborsRun: "Hämta grannar",
      neighborsEmpty: "Inga grannar hittades.",
      nodeCol: "Nod",
      edgeKindCol: "Kant",
      weightCol: "Vikt",
      gapTitle: "Täcknings- & gapmatris",
      gapSubtitle: "Uppmätt bestånd mot de konfigurerade blandningsmålen per förmåga, signatur och nivå — en SQL-vy över katalogen, aldrig hårdkodad.",
      tier: "Nivå",
      gapHave: "Är",
      gapTarget: "Mål",
      gapWeight: "Vikt",
      gapPriority: "Prioritet",
      targetsTitle: "Definiera blandningsmål",
      targetsSubtitle: "Mål bär upphovsman och tidpunkt; utan mål visar matrisen ärligt det tomma tillståndet.",
      addTargetRow: "Lägg till rad",
      saveTargets: "Spara mål",
      targetsSaved: "Mål sparade",
      statusCol: "Status",
      tdvTitle: "Förseglad dataversion",
      tdvSubtitle: "Dataversionen är oföränderlig och sammansatt av förseglade shards; en ny ersätter den föregående.",
      createTdv: "Skapa TDV-utkast",
      tdvCreated: "TDV-utkast skapat",
      tdvId: "TDV",
      tdvName: "Namn",
      tdvMembers: "Medlemmar",
      tdvCreatedAt: "Skapad",
      tdvSealedAt: "Förseglad",
      tdvStatusDraft: "utkast",
      tdvStatusSealed: "förseglad",
      sealTdv: "Försegla",
      tdvSealed: "TDV förseglad",
      tdvEmpty: "Ingen Train Data Version ännu — den sätts samman av förseglade shards.",
      compatTitle: "Kompatibilitetskontroll mellan arkitektur och data",
      compatSubtitle: "Regler R1–R12 över två maskinläsbara dokument; instrumentpanelen visar motorns lagrade rapport och beräknar ingen egen dom.",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "inte ALL-GREEN",
      compatRun: "Kör kontroll",
      compatChecked: "Kontroll utförd",
      compatSelectTdv: "Välj en TDV i listan ovan för att se dess rapport.",
      compatNoReport: "Ingen lagrad kompatibilitetsrapport finns för denna TDV ännu.",
      compatDraftNote: "Arkitekturens datagränssnitt är ett utkast — tokenizer- och codec-artefakter finns ännu inte; kontrollen aktiveras med den första tokenizer-utgåvan och den första förseglade TDV:n.",
      compatRule: "Regel",
      compatTitleCol: "Titel",
      compatKind: "Slag",
      compatEvidence: "Jämförda värden (bevis)",
      kindHard: "hård",
      kindWarn: "upplysning",
      reportsTitle: "Lagrade rapporter",
      reportsEmpty: "Ingen kompatibilitetsrapport lagrad ännu.",
      phaseLabel: "Träningsfas",
      phaseA: "Fas A — beredskap & evolution",
      phaseB: "Fas B — träning pågår, arkitekturen fryst",
      checklistTitle: "Träningsberedskap (fas A-checklista)",
      checklistSubtitle: "Villkor beräknade live; starten förblir spärrad tills varje punkt är grön, och varje ouppfylld punkt namnges.",
      checklistReady: "redo",
      checklistUnmet: "{count} punkter ouppfyllda",
      checklistUnavailable: "Checklistan kan inte nås.",
      itemSatisfied: "uppfylld",
      itemUnsatisfied: "ouppfylld",
      startTraining: "Starta fas B",
      strandTitle: 'Träningssträng',
      strandSubtitle: 'Vilken modellsträng som tränas när alla förutsättningar är uppfyllda; den ovalda strängen fortsätter förbereda data men startar aldrig.',
      strandSelectedBadge: 'vald',
      strandExplain: 'Autopiloten tränar {selected}. {other} fortsätter samla och förbereda men startar inte så länge den inte är vald.',
      strandSwitched: 'Valet sparat.',
      strandSwitchFailed: 'Bytet misslyckades.',
      strandUnavailable: 'Denna backend levererar ännu inga strängar; väljaren visas efter nästa core-utrullning.',
      trainingStarted: "Fas B startad",
      startBlocked: "Start spärrad — ouppfyllt: {items}",
      selectedTdvLabel: "Vald dataversion",
      computedAt: "Beräknad",
      runsTitle: "Träningskörningar",
      runsSubtitle: "Endast verkliga körningar ur katalogen; någon simulerad träningsprocess finns inte.",
      runId: "Körning",
      archVersion: "Arkitektur",
      presetCol: "Preset",
      seqLenCol: "Sekvenslängd",
      stepCol: "Steg",
      lossCol: "Loss",
      runStarted: "Startad",
      runFinished: "Avslutad",
      runsEmpty: "Ingen träningskörning ännu.",
      abortRun: "Avbryt",
      confirmAbort: "Avbryta denna träningskörning?",
      runAborted: "Avbrott begärt",
      benchLink: "Benchmark",
      benchTitle: "Benchmarkrapporter",
      benchSubtitle: "Den frysta, versionerade sviten körs automatiskt efter varje träning; varje rapport lagras i laken och visas här.",
      benchEmpty: "Ingen benchmarkrapport ännu.",
      suiteVersion: "Svit",
      benchOpen: "Öppna",
      benchReportFor: "Benchmarkrapport för körning {run}",
      benchNoMarkdown: "Denna rapport bär inget renderat dokument; råresultaten står nedan.",
      exportsTitle: "Exporter",
      exportsSubtitle: "Nedladdningar finns uteslutande för exporter av slutförda verkliga träningskörningar.",
      exportId: "Export",
      exportSize: "Storlek",
      exportSha: "SHA-256",
      download: "Ladda ned",
      exportsEmpty: "Ingen export ännu — den uppstår först ur en slutförd verklig träningskörning.",
      hfTitle: "HuggingFace-publiceringar",
      hfSubtitle: "Varje uppladdning sker privat; synligheten verifieras via API efter uppladdningen. Ett icke-privat resultat är ett feltillstånd som stoppar kretsloppet.",
      hfEmpty: "Ingen publicering ännu.",
      hfRepo: "Repositorium",
      hfState: "Tillstånd",
      hfVisibility: "Synlighet",
      hfPrivateVerified: "privat — verifierad",
      hfUnverified: "ännu inte verifierad",
      hfVerifiedAt: "Verifierad",
      connectTitle: "Anslut Block Storage",
      connectSubtitle: "Inloggning i lagringsleverantörens inloggningsfönster; lagringen kopplas till kontot som bekräftar.",
      webConnectStart: "Anslut med lagringsleverantören",
      webConnectWaiting: "Väntar på bekräftelsen i lagringsleverantörens inloggningsfönster…",
      webConnectHint: "Efter bekräftelsen ansluts lagringen automatiskt; dialogen uppdateras själv.",
      publicIdentity: "Publik appidentitet (rclone, delad kvot)",
      publicIdentityNote: "Lagringsleverantörens inloggningsfönster visar ”rclone” som begärande app — den offentligt delade identiteten; ett eget client-ID (GDRIVE_OAUTH_CLIENT_ID) ersätter den när som helst.",
      manualHint: "Efter bekräftelsen visar webbläsaren en onåbar localhost-sida. Kopiera värdet för parametern code= från adressfältet och klistra in det här (hela adressen fungerar också).",
      manualCodeLabel: "Auktoriseringskod",
      manualSubmit: "Lös in koden",
      deviceInstead: "Använd en enhetskod i stället",
      licenseAcceptLink: "Bekräfta licensen på Hugging Face",
      deviceFlowTitle: "Anslut Block Storage (device flow)",
      deviceFlowSubtitle: "Motorn startar leverantörens inloggningsflöde för enheter; bekräftelsen sker på en andra enhet och avfrågas med begränsade intervall.",
      deviceFlowStart: "Starta inloggningsflödet",
      deviceFlowCode: "Enhetskod",
      deviceFlowOpenUrl: "Öppna bekräftelsesidan",
      deviceFlowWaiting: "Väntar på bekräftelse — avfrågan följer det intervall leverantören föreskriver.",
      deviceFlowAuthorized: "Ansluten",
      deviceFlowExpired: "Enhetskoden har gått ut — starta inloggningsflödet igen.",
      readinessTitle: "Beredskap för träning",
      readinessSubtitle: "Den uppmätta vägen till den första träningskörningen, steg för steg.",
      readinessCounter: "{green} av {total} uppfyllda",
      readinessReady: "Redo för träning",
      unblockLabel: "Nästa steg",
      readinessUnavailable: "Beredskapsöversikten är ännu inte utrullad i backend. Så snart endpointen är live visas det uppmätta läget här.",
      stageStates: {
        ok: "uppfylld",
        active: "pågår",
        waiting: "väntar",
        blocked: "blockerad",
      },
    },
    gt: {
      loading: '…',
      unavailable: 'otillgängligt',
      equilibrium: 'Optimalt driftstillstånd uppnått: alla förfrågningar har besvarats, alla uppgiftsöverlämningar har behandlats och redundans har undvikits.',
      standby: 'standby',
      defTitle: 'Operativ Teamkoordinering & Prestandamått',
      defSubtitle: 'Mätning av operativ kommunikations- och överlämningskvalitet för alla AI-roller: fokus på verifierade resultat i stället för improduktiv aktivitet.',
      defPlayers: 'Medverkande Roller & System',
      defPlayersText: 'De tio specialiserade AI-rollerna med sina Webex-botar samt de mänskliga beslutsfattare som anger uppdrag och riktlinjer.',
      defStrategies: 'Kommunikations- & Arbetsprinciper',
      defStrategiesText: 'Direkta svar på frågor, entydiga och fullständiga uppgiftsöverlämningar, undvikande av redundans samt konsekvent slutförande av öppna arbetspaket.',
      defPayoff: 'Operativt Resultatbidrag (Nettonyttovärde)',
      defPayoffText: 'Slutförda arbetspaket, framgångsrikt behandlade överlämningar och besvarade frågor — minus friktionsförluster (redundans, obehandlade överlämningar, obesvarade frågor).',
      defEquilibrium: 'Optimalt Driftstillstånd (Koordineringsjämvikt)',
      defEquilibriumText: 'Måltillstånd för samarbetet: varje fråga besvaras i tid, varje uppgiftsöverlämning tas om hand, ingen information skickas dubbelt och inget arbetspaket blir liggande.',
      playersTitle: 'Prestandaöversikt per Roll (Positioner)',
      playersSubtitle: 'Operativa kommunikations- och leveransnyckeltal per roll: sakbidrag och överlämningar (senaste 7 dagarna) samt möten och slutförda arbetspaket (senaste 30 dagarna).',
      playersHint: 'Nettonyttovärde = 3 × slutförda arbetspaket + behandlade överlämningar − friktionsförluster (obehandlade överlämningar räknas dubbelt). Ett negativt värde indikerar koordineringsbehov.',
      player: 'Roll / Position',
      contributions: 'Inlägg',
      meetingTurns: 'Möten',
      handovers: 'Överlämningar',
      consumedShort: 'hanterade',
      refusedShort: 'avvisade',
      delivery: 'Leverans',
      pausedTurns: 'Pausade turer',
      pausedTurnsHint: 'Turer som sparats i kollegans egen brevlåda eftersom modellerna inte kunde betjäna dem just då. Inga överlämningar.',
      closedOpen: 'avslutade / öppna',
      noise: 'Friktionsförlust',
      utility: 'Nettobidrag',
      meetingsLine: '{held} möten, {turns} inlägg, {u} obesvarade tilltal (30 dagar).',
      interactionsTitle: 'Uppgiftsöverlämningar mellan Roller (Handover-matris)',
      interactionsSubtitle: 'Riktade uppgiftsöverlämningar mellan inkorgar (senaste 7 dagarna): antal, leveranstid samt behandlade och avvisade överlämningar.',
      interactionsHint: 'En uppgiftsöverlämning räknas som slutförd först när den har behandlats av mottagaren; avvisade eller obehandlade överlämningar markeras som processavvikelser.',
      interactionsEmpty: 'Inga överlämningar i fönstret.',
      from: 'Från',
      to: 'Till',
      messages: 'Meddelanden',
      consumed: 'hanterade',
      refused: 'avvisade',
      deviationsTitle: 'Processavvikelser & Aktiva Flaskhalsar',
      deviationsSubtitle: 'Aktuella koordineringsbrister: obesvarade frågor, obehandlade uppgiftsöverlämningar, redundanta inlägg eller blockerade arbetspaket.',
      dev_unanswered_question: 'Obesvarad fråga (tidsgräns överskriden)',
      dev_dead_air: 'Uppgiftsöverlämning utan återkoppling',
      dev_repetition: 'Upprepning i mötet',
      dev_meeting_unanswered: 'Direkt förfrågan utan svar',
      dev_work_blocked: 'Arbete blockerat',
      dev_handover_hop_budget_reached: 'Hoppbudget för överlämningar överskriden',
      dev_commitment_unkept: 'Sprintåtagande ej hållet',
      devWithheld: 'tillbakahållet',
      devRepetition: 'upprepning',
      devDeadAir: 'obehandlad överlämning',
      devMeetingUnanswered: 'obesvarat',
      effectiveThresholdCol: 'Eff. tröskel',
      excessHopsLabel: 'Överskjutande överlämningshopp',
      timeTitle: 'Cykeltider & Produktivitetsjämförelse (AI vs. manuellt arbete)',
      timeSubtitle: 'Uppmätt AI-bearbetningstid för slutförda utvecklingsuppgifter jämfört med uppskattad manuell arbetsinsats.',
      timeHint: 'Kalkylmässiga referensvärden för arbetsuppskattning; konfigurerbara av ledningen.',
      avgCycle: 'Genomsn. AI-cykel',
      fromTasks: 'från {n} uppgifter',
      speedup: 'Hastighetsökning',
      speedupHint: '{h} mänskliga timmar antagna per arbetsstycke',
      humanDelivered: 'Levererade persondagar',
      humanDays: 'persondagar',
      forecast: 'Prognos för öppet arbete: {d} persondagar',
      sizes: 'Storlekar',
      sizeSmall: 'små',
      sizeMedium: 'medelstora',
      sizeLarge: 'stora',
      scrumTitle: 'Scrum',
      scrumSubtitle: 'Sprinten, dess story points och velocity, ur företagets egna data',
      sprintLabel: 'Sprint {n}',
      ends: 'slutar',
      committedPts: 'Åtagna poäng',
      deliveredPts: 'Levererade poäng',
      remainingPts: 'Återstående poäng',
      burndownTitle: 'Burndown (återstående poäng per dag)',
      velocityTitle: 'Velocity för avslutade sprintar',
      predictability: 'förutsägbarhet',
      forecastLine: 'Rullande velocity {v} poäng per sprint · backlogg {b} poäng ≈ {s} sprintar',
      noSprint: 'Ingen sprint pågår; nästa planering öppnar en.',
      noItems: 'Inget har åtagits ännu; sprinten tar det människorna kommer med.',
      colItem: 'Post',
      colOwner: 'Ansvarig',
      colPoints: 'Poäng',
      colState: 'Status',
      itemDone: 'levererad',
      itemOpen: 'öppen',
      unestimated: 'oskattad',
      addedBy: 'tillagd av {who}',
      setGoal: 'Sprintmål',
      sprintDaysLabel: 'Sprintlängd (dagar)',
      save: 'Spara',
      endSprint: 'Avsluta sprinten nu',
      confirmEndSprint: 'Avsluta sprinten nu? Review, retrospektiv och nästa planering hålls genast.',
      planNow: 'Håll den första planeringen nu',
      confirmPlanNow: 'Hålla sprintplaneringen nu? Den öppnar den första sprinten i pAIoneer-scrum.',
      sprintPointsCol: 'Sprintpoäng',
      ceremonySpaceLabel: 'Ceremonirum',
      scrumOfScrums: 'Håll Scrum of Scrums',
      confirmScrumOfScrums: 'Hålla Scrum of Scrums över alla affärsenheter nu?',
      lastScrumOfScrumsTitle: 'Senaste Scrum of Scrums',
      escalatedImpedimentsTitle: 'Eskalerade hinder',
      unitBreakdownTitle: 'Sprintuppdelning per affärsenhet',
      colUnit: 'Affärsenhet',
      colWip: 'Öppet arbete',
      colImpediments: 'Hinder',
    },
    nav: {
      groups: {
        gametheory: 'Teamkoordinering & Scrum',
        demos: 'Liveförhandsvisningar',
        sovereign: 'Suverän LLM',
        today: 'Daglig Översikt & Driftcentral',
        organisation: 'Organisation',
        work: 'Arbete',
        communication: 'Kommunikation',
        memory: 'Minne',
        platform: 'Plattform',
        products: 'Produkter',
        identity: 'Identitet',
      },
      pages: {
        gametheory: 'Teamkoordinering & Scrum',
        demos: 'Liveförhandsvisningar',
        llm: 'LLM-arkitektur — artikel',
        training: 'Data Lake & AI-modellträning',
        today: 'Daglig Översikt & Driftcentral',
        work: 'Arbetspaket och projekt',
        coding: 'Kodningsuppgifter',
        gitlab: 'GitLab & Image-byggen',
        agents: 'Agenter och utkast',
        research: 'Efterforskningar',
        webex: 'Webex-rum',
        mailboxes: 'Brevlådor',
        conversations: 'Samtal och konversationer',
        meetings: 'Möten',
        engines: 'AI-motorer & GPU',
        usage: 'Förbrukning och budgetar',
        workloads: 'Containertjänster',
        orchestrator: 'Veridion MCP-orkestrerare',
      },
      sections: {
        demos: {
          previews: 'Liveförhandsvisningar',
        },
        llm: {
          paper: 'Artikel',
          monitoring: 'Övervakning',
        },
        training: {
          autopilot: "Autopilot",
          storage: "Molnlagring & mappträd",
          acquisition: "Datainsamling & förbearbetning",
          data: "Data & kunskapsgraf",
          training: "Träning & publicering",
        },
        platform: {
          nodes: 'Klusternoder',
          events: 'Händelser',
        },
        smtm: {
          runtime: 'Körningsstyrning',
          prediction: 'Prognosstyrning',
          status: 'Datastatus',
          reporting: 'Signaler',
          training: 'Modeller',
          console: 'Träningskonsol',
        },
        agentic: {
          overview: 'Översikt',
          tools: 'Verktyg',
          mcp: 'MCP-servrar',
          activity: 'Aktivitet',
        },
        'company-memory': {
          content: 'Innehåll',
          search: 'Sökning och lägesbilder',
          facts: 'Fakta',
          entity: 'Entiteter',
          remember: 'Registrera',
          audit: 'Revisionslogg',
          console: 'Frågekonsol',
          stores: 'Lager',
          graph: 'Kunskapsgraf',
          day: 'Dag',
            bubbles: 'Avdelnings-kunskapsdomäner & Forskning'
        },
        organisation: {
          chart: 'Organisationsschema',
          colleagues: 'AI-kollegor och brevlådor',
          voices: 'Röster',
          people: 'Personer och rum',
          approvals: 'Godkännanden och scheman',
          edit: 'Redigera organisation',
        },
        work: {
          items: 'Arbetspaket',
          projects: 'Projekt under utveckling',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'Image-byggen',
        },
        agents: {
          agents: 'Agenter',
          designs: 'Agentutkast',
          definitions: 'Definitioner',
        },
        usage: {
          identities: 'Per identitet',
          budgets: 'Tokenbudgetar',
          company: 'Företagsinstans',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'Körtid',
          mcp: 'MCP-servrar',
          tools: 'Verktyg',
          activity: 'Aktivitet',
        },
      },
      attentionTitle: 'Kräver åtgärd',
      attentionSubtitle: 'Tillstånd från alla områden som kräver ett ingrepp. Ett klick öppnar avsnittet.',
      attentionNone: 'Inget kräver åtgärd.',
      stateTitle: 'Driftläge',
      none: 'inga',
      readyOf: '{ready} av {total} redo',
      connectedOf: '{connected} av {total} anslutna',
      registeredOf: '{registered} av {total} registrerade',
      showMore: 'Visa fler',
      shownOf: '{shown} av {total}',
      expand: 'Fäll ut',
      collapse: 'Fäll ihop',
      service: 'Tjänst',
      serviceLinks: 'Länkar',
      controlsTitle: 'Styrning av Veridion Core',
      confirmRemove: 'Ta bort {what}?',
      companyIdentitiesTitle: 'Gateway-identiteter för företagsinstansen',
      companyIdentitiesSubtitle: 'Orkestrerarens och Veridion Cores token i gatewayens löpande fönster, varje identitet med sin budget.',
      conversationsTitle: 'Konversationer från instrumentpanelen',
      conversationsSubtitle: 'Per AI-kollega de skriftliga konversationerna från instrumentpanelen; att skriva och ringa öppnar en dialog över sidan.',
      conversationCount: 'Meddelanden',
      conversationLastWritten: 'Senast skrivet',
      conversationLastAnswered: 'Senast besvarat',
      exchangesTitle: 'Meddelanden och svar',
      exchangesSubtitle: 'Varje meddelande från instrumentpanelen med AI-kollegans svar, nyaste först.',
      conversationMessage: 'Meddelande',
      conversationAnswer: 'Svar',
      today: {
        wordTitle: 'Aktuellt ledningsdirektiv',
        wordNone: 'Inget öppet ledningsdirektiv är för närvarande registrerat.',
        sinceTitle: 'Händelser sedan senaste besök',
        sinceState: 'sedan {time}',
        workTitle: 'Aktiva uppgifter & Ansvar',
        workNone: 'Inget arbetspaket pågår.',
        nextMeeting: 'Nästa möte',
        lastMeeting: 'Senaste möte',
      },
      work: {
        title: 'Arbetspaket',
        subtitle: 'Varje öppet arbetspaket i företagsminnet med ansvarig, tillstånd, prioritet, förfallodag och resultaten av dess scenarier; titeln öppnar det i grafen.',
        item: 'Arbetspaket',
        kind: 'Typ',
        owner: 'Ansvarig',
        status: 'Tillstånd',
        priority: 'Prioritet',
        due: 'Förfallodag',
        scenarios: 'Scenarier',
        updated: 'Uppdaterat',
        none: 'Inget öppet arbetspaket.',
        all: 'Alla ansvariga',
      },
      meetings: {
        subtitle: 'AI-kollegornas möten som Veridion Core registrerar dem: tidslucka, sammanfattning och de åtaganden som blev arbete.',
        slot: 'Tidslucka',
        kind: 'Typ',
        started: 'Började',
        ended: 'Avslutades',
        summary: 'Sammanfattning',
        commitments: 'Åtaganden',
        hold: 'Håll ett möte nu',
        held: 'Mötet har kallats.',
        notHeld: 'Ett möte pågår eller hölls under den senaste halvtimmen.',
        holdFailed: 'Mötet kunde inte kallas',
        none: 'Inget möte registrerat ännu.',
      },
      research: {
        title: 'Efterforskningar',
        subtitle: 'AI-kollegornas efterforskningar från företagets tidslinje, nyaste först.',
      },
      attention: {
        toneError: 'Fel',
        toneWarning: 'Notis',
        state: {
          platform: '{ready} av {workloads} workloads redo, {nodes} av {total} noder redo, {restarts} omstarter.',
          gateway: '{state}; {models} modeller routade, {backends} av {total} serving-backends redo.',
          engine: '{engine}: {running} pågående, {waiting} väntande',
          usage: '{tokens} token över {identities} identiteter i fönstret {window}.',
          smtm: 'Prognosgrind {gate}, ombyggnad {rebuild}; {online} av {models} modeller online, {failed} misslyckade.',
          smtmSignals: '{open} öppna signaler, {resolved} avgjorda, {failed} leveranser misslyckade.',
          smtmVeridion: '{connected} av {servers} MCP-servrar anslutna.',
          company: 'Orkestrerare {status}; {ready} av {workloads} workloads redo; Veridion Core {core}; {agents} agenter körs, {waiting} väntar.',
          companyWebex: '{registered} av {bots} bot-webhooks registrerade.',
          approvals: '{approvals} öppna godkännanden; {tasks} kodningsuppgifter väntar på en person eller en granskning.',
          sessions: '{users} inloggade användare, {sessions} sessioner, {mfa} verifierade, {total} konton.',
          mail: 'SMTP {state}.',
        },
        platformUnreadable: 'Plattformens tillstånd går inte att läsa.',
        nodeNotReady: 'Noden {name} är inte redo.',
        nodePressure: 'Noden {name} rapporterar brist: {pressure}.',
        workloadDown: '{name} ({namespace}): {ready} av {desired} redo.',
        gatewayNotProgrammed: 'AI-gatewayen är inte programmerad.',
        smtmGateClosed: 'Prognosgrinden är stängd.',
        smtmRebuild: 'En ombyggnad är markerad.',
        smtmHint: 'Datastatus: {hint}.',
        smtmDeliveryFailed: '{count} signalleveranser misslyckades.',
        smtmModelsFailed: '{count} modeller rapporterar ett fel.',
        mcpUnreachable: 'MCP-servern {server} i {instance} kan inte nås.',
        partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} svarar inte.',
        parts: {
          orchestrator: 'orkestreraren',
          webex: 'Webex-bryggan',
          knowledge: 'kunskapsbasen',
          core: 'Veridion Core',
          mcp: 'MCP-servrarna',
          usage: 'förbrukningsregistret',
          gateway: 'gatewayförbrukningen',
        },
        emergencyStop: 'Nödstoppet i Veridion Core är aktivt.',
        coreMisconfigured: 'Veridion Core saknar inställningar: {missing}.',
        agentsWaiting: '{count} agenter väntar på ett svar.',
        hostedNotRunning: '{agent} körs inte.',
        webhookMissing: 'Webhooken för {bot} är inte registrerad.',
        readerNotAuthorised: 'Läsning av företagets utrymmen är inte godkänd.',
        approvalOpen: 'Öppet godkännande ({position}): {question}',
        taskWaiting: 'Kodningsuppgift väntar på en person: {title}',
        taskReview: 'Merge request redo för granskning: {title}',
      },
    },
    ops: {
      showDetails: 'Detaljer',
      hideDetails: 'Stäng',
      mcpVersion: 'Version',
      mcpUrl: 'Adress',
      mcpProtocol: 'Transport och protokoll',
      mcpLastRefresh: 'Senast frågad',
      mcpError: 'Fel',
      noTools: 'Inga verktyg rapporterade.',
      toolServer: 'Ursprung',
      toolAccess: 'Åtkomst',
      toolBuiltIn: 'Veridion',
      accessReadOnly: 'läser',
      accessWrites: 'skriver',
      accessDestructive: 'ändrar data',
      accessUndeclared: 'ej angivet',
      usageTitle: 'Förbrukning',
      smtmUsageSubtitle: 'Modellanrop, tokens och leverantörsrapporterade kostnader för de senaste 30 dagarna.',
      usageByPerson: 'Per person',
      usageByModel: 'Per modell',
      usageByDay: 'Per dag',
      model: 'Modell',
      day: 'Dag',
      promptTokens: 'Indatatokens',
      completionTokens: 'Utdatatokens',
      noUsage: 'Ingen förbrukning bokförd.',
      runtimeTitle: 'Körning',
      runtimeSubtitle: 'Hur orkestreraren i den här instansen når sina modeller och kopplar in sina verktyg.',
      executionMode: 'Körning',
      providerProtocol: 'Protokoll till modellen',
      contextWindow: 'Kontextfönster',
      requestTimeout: 'Tidsgräns per begäran',
      diagnostics: 'Diagnostik',
      diagnosticsOn: 'på',
      diagnosticsOff: 'av (prestandaläge)',
      externalServers: 'Anslutna MCP-servrar',
      mcpEndpoint: 'MCP-slutpunkt',
      workloadsTitle: 'Arbetslaster',
      workloadsSubtitle: 'Arbetslasterna i namnrymden paioneer-veridion så som Kubernetes rapporterar dem.',
      botsTitle: 'Botar',
      botsSubtitle: 'Organisationens botar, var och en med sin webhook, och bryggans tjänster.',
      botAddress: 'Adress',
      cardWebhook: 'Kort-webhook',
      webhookState: 'Tillstånd',
      noBots: 'Bryggan rapporterar inga botar.',
      bridgeServices: {
        knowledgeBase: 'Kunskapsbas',
        webResearch: 'Internetsökning',
        osint: 'OSINT',
        anonymizer: 'Anonymisering',
      },
      connected: 'ansluten',
      notConnected: 'inte ansluten',
      activeRooms: 'Aktiva rum',
      allowedRooms: 'Tillåtna rum',
      surface: 'Yta',
      missingSettings: 'Saknade inställningar',
      none: 'inga',
      instanceToolsTitle: 'Orkestrerarens verktyg',
      instanceToolsSubtitle: 'Verktygen som orkestreraren i företagsinstansen har registrerat.',
      openMailbox: 'Brevlåda',
      positionMailboxHint: 'AI-kollegor arbetar med överlämningar från andra AI-kollegor; uppdrag till en AI-kollega ges i dess Webex-utrymme.',
      mailboxesTitle: 'Brevlådor',
      mailboxesSubtitle: 'Per agent, vad som väntar i dess brevlåda, har levererats och har lästs. Ett klick på en rad filtrerar meddelandena.',
      readAt: 'Läst',
      refresh: 'Uppdatera',
      mailbox: 'Brevlåda',
      mailboxKind: 'Typ',
      mailboxKinds: {
        position: 'AI-kollega',
        hosted: 'Värdad agent',
        graph: 'Agent',
      },
      lastMessage: 'Senaste meddelande',
      noMailboxes: 'Ingen brevlåda kan läsas.',
      messagesTitle: 'Meddelanden',
      messagesSubtitle: 'Meddelanden, kommandon och överlämningar, nyaste först. Ett klick visar hela texten.',
      allMailboxes: 'Alla brevlådor',
      allStates: 'Alla tillstånd',
      time: 'Tid',
      from: 'Från',
      to: 'Till',
      messageKind: 'Typ',
      content: 'Innehåll',
      reply: 'Svar',
      noMessages: 'Inga meddelanden.',
      messageKinds: {
        message: 'Meddelande',
        handover: 'Överlämning',
        command: 'Kommando',
        resume: 'Återupptagning',
        subagent_result: 'Resultat från en underagent',
        review: 'Granskning',
      },
      buildsTitle: 'Byggen',
      buildsSubtitle: 'Avbildningarna som Veridion Core har byggt för agenter, nyaste först.',
      image: 'Avbildning',
      started: 'Startad',
      finished: 'Klar',
      noBuilds: 'Inga byggen.',
      coreToolsTitle: 'Agenternas verktyg',
      coreToolsSubtitle: 'Orkestrerarens verktyg som Veridion Core erbjuder sina agenter.',
      description: 'Beskrivning',
      coreDailyTitle: 'Förbrukning per dag och modell',
      coreDailySubtitle: 'Veridion Core-modellanrop de senaste 30 dagarna, per agent och modell.',
      coreActivityTitle: 'Aktivitet i Veridion Core',
      coreActivitySubtitle: 'Händelser för agenter, AI-kollegor och överlämningar i Veridion Core, nyaste först.',
      event: 'Händelse',
      tool: 'Verktyg',
      detail: 'Detalj',
    },
    tabCompanyMemory: 'Företagsminne',
    llmPaper: {
      subtitle: 'Den genererade vetenskapliga beskrivningen av den suveräna modellarkitekturen — återgiven ur det artikel-dokument som Veridion Core för till den aktiva specifikationen.',
      summaryTitle: 'Vad denna sida visar',
      summaryBody: 'Veridion Core för ett genererat vetenskapligt dokument till den aktiva modellarkitekturen: titel, sammanfattning, numrerade avsnitt, arkitekturdiagram, tabeller och referenser kommer oförändrade från backend; designvärden är märkta som sådana, och sidan hittar inte på något.',
      refresh: 'Uppdatera',
      exportPdf: 'Exportera som PDF',
      strandTraining: 'tränas',
      strandSelected: 'vald',
      lcTitle: "Implementation och livscykel",
      lcSelectedTrains: "tränas härnäst",
      lcCollectsOnly: "samlar & förbereder — startar inte",
      lcSpec: "Specifikation",
      lcFrozen: "fryst",
      lcArtifacts: "Artefakter (tokeniserare/codec)",
      lcReleased: "släppta",
      lcNotReleased: "ännu inte byggda",
      lcCodecOpen: "codec återstår",
      lcData: "Datatrösklar",
      lcThresholdsMet: "uppfyllda",
      lcAreasReached: "dataplan: {met} av {total} områden nådda",
      lcNoLake: "datasjön onåbar",
      lcStage_trainer_image: "Tränarimage",
      lcStage_sealed_tdv: "TDV förseglad",
      lcStage_compat_all_green: "Kompatibilitet ALL-GREEN",
      lcStage_vram_budget: "VRAM-budget",
      lcTraining: "Träning",
      lcAuto: "startar automatiskt när trösklarna uppfylls",
      lcBench: "Benchmark",
      lcBenchRows: "mätningar",
      lcNoneYet: "inga än",
      lcRelease: "Export · Hugging Face (privat) · register",
      lcReleaseRows: "artefakter",
      lcReleaseNote: "efter träningen: privat-verifierad uppladdning + registerpost",
      lcPipeline: "Träningspipeline",
      lcDone: "klart",
      lcActive: "aktiv",
      lcWaiting: "väntar",
      lcBlocked: "blockerad",
      lcCapability: "Förmåga",
      lcSamples: "Exempel",
      lcByLanguage: "per språk",
      lcForeign: 'annan gren',
      lcCorpus: 'Korpustoken',
      lcCorpusNone: 'inte tokeniserad ännu',
      loading: 'Läser in …',
      unavailable: 'Dokumentet kan inte nås.',
      noPaper: 'Denna version av Veridion Core levererar ännu inget artikel-dokument. Sidan visar därför inget påhittat.',
      abstract: 'Sammanfattning',
      references: 'Referenser',
      appendix: 'Bilaga',
      figure: 'Figur',
      lastUpdated: 'Senast uppdaterad',
      empty: 'Inga poster.',
    },
    llmMonitor: {
      summary: "Driftövervakning av modellen: status, data, GPU, kärnor och genomströmning, utvärderingar och händelser — uppmätt från Veridion Core och data laken, inget påhittat.",
      archTitle: 'Arkitekturstatus',
      archSubtitle: "Den aktiva arkitekturen med datagränssnittets tillstånd och frysningstillståndet.",
      version: 'Version',
      codename: 'Kodnamn',
      statusLabel: 'Status',
      interfaceStatus: 'Datagränssnitt',
      specSha: 'Specifikationshash (SHA-256, förkortad)',
      promotedAt: 'Befordrad',
      frozenLabel: 'Fryst',
      frozenYes: 'Ja',
      frozenNo: 'Nej',
      stateWord_active: "aktiv",
      stateWord_draft: "utkast",
      stateWord_released: "frisläppt",
      stateWord_candidate: "kandidat",
      stateWord_retired: "avslutad",
      gpuModel: "Grafikkort",
      gpuTotal: "Totalt grafikminne",
      gpuWindow: "Träningsfönster (uppmätt)",
      gpuMeasuredAt: "Uppmätt",
      gpuSource: "Mätkälla",
      gpuServing: "Servering",
      gpuInferenceTarget: "Mål för inferens på ett kort",
      vramTitle: 'GPU & VRAM-budget',
      vramSubtitle: 'Grafikkortets uppmätta VRAM-budget så som Veridion Core för den.',
      vramNone: 'Ingen VRAM-budget i posten.',
      gateTitle: 'Befordringsgrind',
      gateSubtitle: 'Policyn som avgör när en kandidatarkitektur ersätter den aktiva, med de krävda måtten och deras vikter.',
      metric: 'Mått',
      weight: 'Vikt',
      gateNone: 'Inga krävda mått registrerade.',
      candidatesTitle: 'Kandidater',
      candidatesNone: 'Inga kandidatarkitekturer.',
      evidenceTitle: 'Utvärderingar',
      evidenceNone: 'Inga uppmätta utvärderingar ännu.',
      benchmark: 'Benchmark',
      suite: 'Svit',
      score: 'Resultat',
      evaluator: 'Utvärderare',
      date: 'Datum',
      changelogTitle: 'Ändringshistorik',
      changelogNone: 'Inga arkitekturversioner i historiken ännu.',
      summaryLabel: 'Sammanfattning',
      createdAt: 'Skapad',
      supersededAt: 'Ersatt',
      eventsTitle: 'Händelser',
      eventsNone: 'Inga händelser registrerade.',
      implTitle: 'Strängens implementeringsstatus',
      implSubtitle: "Uppmätta fakta: datagränssnittets artefakter, urval, tokenkorpus och vektorindex; dataplanen per område finns i lägesbilden.",
      implSelected: 'Träningssträng',
      implSelectedYes: 'vald — tränas härnäst',
      implSelectedNo: 'förbereder endast (startar aldrig)',
      implTokenizer: 'Tokenizer-artefakt',
      implCodec: 'Codec-artefakt',
      implNotReleased: 'ännu inte släppt',
      implCapability: 'Förmåga',
      implSamples: 'Exempel (uppmätt/mål)',
      implNoDatalake: 'Exempelframstegen kan inte läsas just nu (datasjöns gränssnitt onåbart).',
      implSwitchHint: 'Valet av träningssträng ändras på träningssidan.',
      implSituationLink: "Var datan står och vad träningen saknar: lägesbilden på träningssidan",
      kernelTitle: 'Kernelacceleration & genomströmning',
      kernelSubtitle: 'Vad kernelsonden mätte på kortet: varje kernel mot sin referens, attention-backenden, genomströmningen för den valda specifikationen — och tidsplanen beräknad ur uppmätta token och uppmätt genomströmning.',
      kernelNone: 'Ingen kernelsond har körts på det här kortet ännu; inget antas.',
      kernelName: 'Kernel',
      kernelVerified: 'Bevisad',
      kernelYes: 'ja',
      kernelNo: 'nej',
      kernelSpeedup: 'Uppsnabbning',
      kernelMaxErr: 'Max. fel',
      kernelError: 'Utfall',
      kernelAttention: 'Attention-backend',
      kernelDocMask: 'Maskering av dokumentgränser',
      kernelThroughput: 'Uppmätt genomströmning (token/s)',
      kernelMicroBatch: 'Mikrobatch',
      kernelMeasuredAt: 'Uppmätt den',
      kernelImage: 'Trainer-avbild (digest)',
      kernelRunPath: 'Kernelväg för senaste körningen',
      kernelRunNone: 'Ingen träningskörning med kernelfakta ännu.',
      kernelPlanTitle: 'Tidsplan (aritmetik över mätningar)',
      kernelPlanTokens: 'Tokenmassa',
      kernelPlanTokensSource: 'Källa för tokenmassan',
      kernelPlanDays: 'Beräknade dagar för ett genomlopp',
      kernelPlanNone: 'Inte uppmätt ännu — utan uppmätt genomströmning eller uppmätt tokenmassa hittas ingen tidsplan på.',
      kernelSourceTdv: 'förseglad träningsdataversion',
      kernelSourceCorpus: 'korpus hittills (inte förseglad)',
      kernelSourcePlan: "artikelns budget",
      implForeign: 'tillhör en annan gren',
      implIndex: 'Vektorindex (graflänkning)',
      implIndexNone: 'inget index rapporterat',
      implIndexDown: 'konfigurerat, svarar inte',
      implIndexPoints: 'punkter',
      implIndexBackfillDone: 'påfyllning klar',
      implIndexBackfillOpen: 'påfyllning pågår',
      implIndexLink: 'Index och deduplicering i sjömonitorn',
      implCorpus: 'Tokenkorpus (råtext)',
    },
    software: {
      arch: {
        execTitle: "Suverän modellarkitektur",
        execSubtitle: "Den enda aktiva arkitekturspecifikationen från Veridion Core: varje siffra är antingen styrkt av ett refererat mätartefakt eller markerad av backend som konstruktionsmål (inte uppmätt).",
        openDatalake: "Öppna Data Lake & AI-modellträning",
        unavailableArch: "Arkitekturdata kan inte nås.",
        frozen: "Fryst — en träningskörning är aktiv",
        notFrozen: "Frisläppt (fas A)",
        version: "Version",
        codename: "Kodnamn",
        statusLabel: "Status",
        createdAt: "Skapad",
        promotedAt: "Befordrad",
        specSha: "Specifikationshash (SHA-256)",
        contextWindow: "Kontextfönster (konstruktion, tokens)",
        dataInterface: "Datagränssnitt",
        diStatus: {
          draft: "utkast",
          complete: "komplett",
          missing: "saknas",
        },
        paramsTitle: "Parameterbalans",
        trainingVramTitle: "Träning-VRAM (deklarerad, GB)",
        inferenceTitle: "Inferens-VRAM (deklarerad, GB)",
        declaredTotal: "Deklarerad summa",
        budgetTitle: "GPU-VRAM-budget (uppmätt)",
        budgetGpu: "GPU",
        budgetTotal: "Total VRAM (MiB)",
        budgetFreed: "Fri träningsbudget (GB)",
        budgetInferenceTarget: "Inferensmål på en GPU (GB)",
        diagramTitle: "Genererat arkitekturdiagram",
        diagramSubtitle: "Deterministiskt genererat ur den lagrade specifikationen; inget handskrivet diagram finns bredvid datan.",
        noDiagram: "Svaret innehåller inget diagram.",
        stagesTitle: "Arkitekturens stegstruktur",
        stagesSubtitle: "Direkt ur den lagrade specifikationen; parametersiffror är konstruktionsvärden.",
        stageCol: "Steg",
        layersCol: "Lager",
        mechanismCol: "Mekanism",
        paramsCol: "Fysiska parametrar (mdr) & primärkällor",
        paramsCross: "tvärgående — medräknad i stegen",
        researchTitle: "Forskningsarkiv för kvant- & frontier-AI",
        researchSubtitle: "Live-rader ur Veridion Cores forskningsarkiv; nya publikationer kommer in via kvantkollegans verktyg, var och en med synligt ursprung.",
        researchEmpty: "Ingen publikation i arkivet ännu.",
        evidenceTitle: "Utvärderingsbevis",
        evidenceSubtitle: "Endast uppmätta, refererade utvärderingar visas här; utan bevis finns ingen poäng.",
        evalMetric: "Mätetal",
        evalBenchmark: "Benchmark",
        evalSuite: "Svit",
        evalScore: "Värde",
        evalEvaluator: "Utvärderare",
        evalDate: "Uppmätt",
        evalArtifact: "Bevisartefakt",
        gateTitle: "Befordringsregler (bevisgrind)",
        gateMetrics: "Obligatoriska mätetal",
        gateEpsilon: "Tolerans (epsilon)",
        gateConfigVersion: "Grindkonfiguration (version)",
        candidatesTitle: "Kandidatkö",
        candidatesSubtitle: "Inlämnade arkitekturkandidater med läget för deras bevis; inlämning sker via forskningsmiljön, aldrig via instrumentpanelen.",
        candidateSubmittedBy: "Inlämnad av",
        candidateEvidence: "Bevis (finns / krävs)",
        candidatesEmpty: "Ingen kandidat inlämnad.",
        changelogTitle: "Konstruktionslogg",
        changelogSubtitle: "Ersatta konstruktionsiterationer — medvetet utan siffror: inget mättes någonsin för dem.",
        changelogSummary: "Sammanfattning",
        changelogEmpty: "Ingen ersatt konstruktion.",
        supersededAt: "Ersatt",
        eventsTitle: "Grindhändelser",
        eventsSubtitle: "Inlämningar, befordringar, avslag och frysövergångar så som grinden har protokollfört dem.",
        eventsEmpty: "Ingen händelse ännu.",
      },
      title: 'Mjukvaruutveckling',
      subtitle: 'Kodagentens uppgifter, företagets GitLab med synkroniseringen från Azure DevOps, merge requests som väntar på granskning och gränserna för GitLab-noden.',
      openGitlab: 'Öppna GitLab',
      openSonar: 'Öppna SonarQube',
      loading: 'Laddar …',
      failed: 'Det fungerade inte',
      done: 'Klart',
      unavailable: 'Inte nåbar',
      capacityTitle: 'GitLab-nod',
      capacitySubtitle: 'Vakten sätter nodens gränser varje minut utifrån serverns belastning; produktionen behåller sin reserv.',
      stateLabel: 'Tillstånd',
      memory: 'Minne',
      cpu: 'CPU',
      disk: 'Disk',
      hostFree: 'Ledigt på servern',
      reserve: 'Reserv för produktionen',
      codingSlots: 'Kodningsuppgifter samtidigt',
      pipelineQuota: 'Pipeline-jobb',
      recentActions: 'Vaktens senaste ingrepp',
      syncTitle: 'Synkronisering från Azure DevOps',
      syncSubtitle: 'GitLabs master följer Azures master; commits som bara GitLab hade sparas under en tagg replaced/<tid>.',
      syncNow: 'Synkronisera nu',
      syncStarted: 'Synkronisering startad',
      azureCommit: 'Azure-master',
      gitlabCommit: 'GitLab-master',
      lastChange: 'Senaste ändring',
      lastRun: 'Senaste körning',
      replaced: 'Sparat under taggar',
      noneReplaced: 'inget',
      jobs: 'Senaste körningar',
      error: 'Fel',
      readyTitle: 'Merge requests redo för granskning',
      readySubtitle: 'Bara merge requests med grön pipeline; de slås ihop i GitLab.',
      noReady: 'Ingen merge request väntar på granskning.',
      tasksTitle: 'Kodningsuppgifter',
      tasksSubtitle: 'Varje programmeringsarbete av kodagenten med tillstånd, merge request och tokens.',
      showFinished: 'Visa avslutade uppgifter',
      task: 'Uppgift',
      requester: 'Beställare',
      statusLabel: 'Tillstånd',
      mergeRequest: 'Merge request',
      pipeline: 'Pipeline',
      tokens: 'Tokens',
      updated: 'Uppdaterad',
      noTasks: 'Ingen kodningsuppgift ännu.',
      phase: 'Steg',
      repository: 'Repository',
      branch: 'Gren',
      openQuestion: 'Öppen fråga',
      result: 'Resultat',
      sendMessage: 'Skriv till uppgiften',
      answerQuestion: 'Besvara frågan',
      urgent: 'Brådskande: styr det pågående steget direkt',
      send: 'Skicka',
      messageSent: 'Levererat till uppgiften',
      confirmCancel: 'Avbryta den här uppgiften? En öppen merge request stängs.',
      course: 'Sessionens förlopp',
      messages: 'Meddelanden',
      events: 'Händelser',
      none: 'inga',
      close: 'Stäng',
      newTitle: 'Ny uppgift',
      newSubtitle: 'Ge kodagenten en uppgift härifrån; följ den här och på dess Webex-kort.',
      brief: 'Vad ska agenten göra?',
      issue: 'YouTrack-ärende (valfritt)',
      create: 'Skapa uppgift',
      created: 'Uppgift skapad',
      usersTitle: 'Administratörer i GitLab',
      usersSubtitle: 'Varje administratör har en GitLab-användare med administratörsrättigheter; housekeepingen håller dem i takt med Keycloak.',
      email: 'E-post',
      gitlabUser: 'GitLab-användare',
      lastHousekeeping: 'Senaste housekeeping',
      sonarDeleted: 'SonarQube-projekt för raderade grenar borttagna',
      previewsTitle: 'Projekt under utveckling',
      previewsSubtitle: 'Varje projekt under utveckling körs exakt en gång från sin första merge: Veridion Core startar huvudgrenens senaste gröna tillstånd (migration eller master) i containrar bakom administratörsinloggningen, förnyar det vid varje grön pipeline, och här startas, stoppas och startas containrarna om. Ett projekt vars pipeline inte bygger något körbart står här med orsaken.',
      previewsSummaryTitle: 'Vad denna vy visar',
      previewsSummaryBody: 'Varje projekt under utveckling kör i en egen förhandsvisningscontainer bakom administratörsinloggningen. Listan överst visar varje projekts senaste körbara läge, tabellen nedanför de körande containrarna med läge, adress och kontroller: öppna, starta, stoppa, starta om.',
      previewProject: 'Projekt',
      previewState: 'Körande läge',
      previewSince: 'Sedan',
      previewAddress: 'Adress',
      previewMergedAt: 'Sammanfogad',
      noPreviews: 'Inget projekt körs.',
      reasonsLabel: 'Blockerande orsaker & Diagnostik',
      noProjects: 'Inget projekt under utveckling.',
      qualityCoverage: 'Testtäckning',
      qualityBugs: 'Buggar',
      qualitySmells: 'Code smells',
      qualityDuplication: 'Duplicering',
      qualityHotspots: 'Öppna hotspots',
      qualityUnavailable: 'Inga SonarQube-mätningar',
      openPreview: 'Öppna',
      startPreview: 'Starta containrar',
      stopPreview: 'Stoppa containrar',
      previewStarted: 'Containrar startade',
      previewStopped: 'Containrar stoppade',
      restartPreview: 'Starta om containrar',
      previewRestarted: 'Containrar omstartade',
      previewControl: 'Containrar',
      resultTitle: 'Resultat i GitLab',
      resultJobs: 'Jobb och artefakter',
      resultSonar: 'SonarQube',
      resultDelivered: 'Levererat',
      previewStatus: {
        starting: 'startar',
        running: 'körs',
        stopped: 'stoppad',
        failed: 'misslyckad',
      },
      capacityStates: {
        ok: 'inom gränserna',
        tight: 'trångt: produktionen behöver utrymmet',
        full: 'fullt: inget nytt arbete',
        node_down: 'noden körs inte',
      },
      status: {
        queued: 'väntar på en ledig plats',
        working: 'pågår',
        waiting: 'väntar på svar',
        review: 'granskas',
        merged: 'sammanslagen i GitLab',
        done: 'klar',
        needs_person: 'behöver en människa',
        rejected: 'stängd utan sammanslagning',
        paused: 'pausad',
        cancelled: 'avbruten',
        failed: 'misslyckad',
      },
      commands: {
        pause: 'Pausa',
        resume: 'Fortsätt',
        cancel: 'Avbryt',
      },
      repositoryChoice: {
        auto: 'Agenten bestämmer',
        company: '{project} (sammanslagning av en människa)',
        own: 'Ett eget projekt i {group}',
      },
      userState: {
        ok: 'i takt',
        created: 'skapad',
        unblocked: 'upplåst',
        'made administrator': 'gjord till administratör',
        blocked: 'blockerad',
      },
    },
    org: {
      write: 'Skriv',
      call: "Ring",
      callTitle: "Samtal med {bot}",
      writeTitle: 'Meddelande till {bot}',
      callConfirmEnd: 'Avsluta samtalet?',
      callSubtitle: 'Mikrofonen är igång under hela samtalet. Boten hälsar med sin röst, svarar kort, frågar vid öppna punkter och kan avbrytas. Varje mening står också i Webex, i direktrummet med boten.',
      callRinging: "Ringer …",
      callConnected: "Ansluten",
      callEnded: "Avslutat",
      callEndedHangup: "Du lade på",
      callEndedClosed: "Anslutningen stängdes",
      callEndedSilence: "90 sekunders tystnad",
      callEndedLimit: "Gränsen på 30 minuter nåddes",
      callEndedError: "Ett fel avslutade samtalet",
      callHangUp: "Lägg på",
      callLevel: "Mikrofonnivå",
      callYou: "Du",
      callSpeaking: "Boten talar …",
      callThinking: 'Svaret genereras …',
      callOvertaken: "överkört av din nästa fråga, inte uttalat",
      callNothingHeard: "Inga ord hördes.",
      callMicDenied: "Webbläsaren nekade mikrofonen; tillåt den för den här sidan och ring igen.",
      callNoVoice: "Rösten är inte tillgänglig just nu; svaret står som text.",
      callRefused: "Samtalet togs inte emot: biljetten var ogiltig eller hade gått ut; ring igen.",
      callFailed: "Samtalet misslyckades",
      voice: "Röst",
      voiceHint: "Rösten som den här kollegan talar med: i Webex när en person ber att få höra svaret, och i telefon. Standard är en talare från ljudmodellen hos OpenRouter; en egen, klonad röst från röstlagret talar via plattformens röstmotor.",
      voiceSave: "Spara röst",
      voiceDefault: "standard",
      voiceNone: "ingen röst",
      voiceCloud: "OpenRouter-talare (standard)",
      voiceOwn: "Egna röster (klonade)",
      voiceUploadTitle: "Ladda upp ett röstprov för den här kollegan",
      voiceUploadHint: "Ljud eller video, högst 25 MB; Core konverterar provet, behåller upp till 20 sekunder, hör dess ord och lagrar bara referensklippet. Kollegan talar genast med den här rösten.",
      voiceUploadName: "Röstens namn",
      voiceUploadConsent: "Jag bekräftar att jag har rätt att använda den här rösten för företaget: den är min egen, eller personen har samtyckt.",
      voiceUploadButton: "Ladda upp prov",
      voiceUploadDone: "Röst sparad",
      voiceTooLarge: "Filen är större än 25 MB.",
      voicesTitle: "Röster",
      voicesSubtitle: "Varje röst i företaget är ett referensklipp i Veridion Cores röstlager; röstmotorn klonar det varje gång en bot talar. De nio tidigare talarna står i det som infångade klipp.",
      voiceSeconds: "Sekunder",
      voiceSource: "Ursprung",
      voiceSourcePreset: "infångad talare",
      voiceSourceUpload: "uppladdat prov",
      voiceAddedBy: "Tillagd av",
      voiceConsentBy: "Samtycke bekräftat av",
      voiceWords: "Klippets ord",
      voiceDelete: "Ta bort",
      voiceConfirmDelete: "Ta bort den här rösten? Kollegor som använder den talar åter med sin standardröst.",
      voiceCapture: "Fånga in förinställningsmotorns talare",
      voiceCaptureHint: "Talar en fast mening per talare genom förinställningsmotorn och sparar den som klipp; körs före bytet av motor.",
      voiceCaptured: "Infångade",
      voiceEnginePresets: "Röstmotorn erbjuder fasta talare; röstlagret används inte.",
      chartTitle: "Organisationsschema",
      executiveTitle: 'Ledningsnivå',
      unitsTitle: 'Affärsenheter',
      unitLead: 'Ansvarig',
      unitSupporting: 'Med stöd av',
      unitMission: 'Uppdrag',
      unitPrefix: 'Trådprefix',
      standingActive: 'aktiv',
      standingStandby: 'standby',
      standbyOn: 'Sätt i standby',
      standbyOff: 'Aktivera',
      standbyHint: 'I standby tar en kollega ingen tur på företagets eget initiativ och kostar inga tokens; ett direkt meddelande från en person besvaras fortfarande.',
      confirmStandby: 'Sätta {name} i standby?',
      confirmActivate: 'Aktivera {name}?',
      activity: 'Aktivitet',
      runtime: 'Körmiljö',
      modelCloud: 'molnmodell',
      modelGpu: 'företagets motor',
      callModel: 'Telefonmodell',
      calls30: 'Samtal, senaste 30 dagarna',
      telemetryLine: '{model} · {prompt}+{completion} tokens · {cost} · öra {asr} ms · tanke {llm} ms · röst {tts} ms · totalt {total} ms{deferred}',
      telemetryDeferred: ' · {count} uppskjutna',
      chartSubtitle: "Veridions AI-kollegor: agenter i Veridion Core, var och en nåbar som sin egen Webex-bott, per område; ovanför dem de mänskliga beslutsfattarna, under dem agenterna utan egen bott och företagets utrymmen, lästa direkt från Veridion Core och Webex.",
      chartPeople: "Mänskliga beslutsfattare",
      chartPeopleText: "De mänskliga beslutsfattarna beslutar allt och agerar i {space}.",
      chartAgentsTitle: "Agenter utan egen bott: kodningsagenten, Veridions MCP-orkestrerare och agenterna som arkitekten bygger arbetar för en AI-kollegas räkning och talar genom dess bott",
      chartDesigned: "Agenter utformade med arkitekten",
      chartFor: "På uppdrag av",
      chartSystemsTitle: "Anslutna system",
      chartSpaceHome: "Hemutrymme för",
      chartSpacePurpose: "Syfte",
      chartRoomsTitle: "Företagets utrymmen i Webex",
      room: "Utrymme",
      roomBots: "Bottar",
      positionsTitle: "AI-kollegor",
      positionsSubtitle: "Varje AI-kollega svarar genom sin egen bot och läser sina utrymmen. Beskrivningen är instruktionen den arbetar efter.",
      bot: "Bot",
      position: "Uppgift",
      statusLabel: "Status",
      tokensUsed: "Använda tokens",
      tokens30: "Tokens, senaste 30 dagarna",
      edit: "Redigera",
      close: "Stäng",
      description: "Beskrivning av AI-kollegan",
      save: "Spara",
      resetDescription: "Återställ standardbeskrivningen",
      interests: "Intresseprofil",
      interestsHint: "Vilka slags punkter och ämnen som angår denna AI-kollega och när den inte berörs. AI-kollegan bedömer varje meddelande i sina utrymmen mot den.",
      threshold: 'Tröskel för ej efterfrågade inlägg',
      thresholdHint: 'Från 1 till 5: hur starkt ett meddelande måste angå AI-kollegan innan den yttrar sig utan att bli tillfrågad. Vid 1 yttrar den sig redan vid låg relevans, vid 5 bara vid hög.',
      saveProfile: "Spara profil",
      tools: "Verktyg",
      decisionMakersTitle: "Beslutsfattare",
      decisionMakersSubtitle: "Var och en av dem kan ge varje godkännande och besvara varje fråga från en AI-kollega i Webex.",
      email: "E-postadress",
      add: "Lägg till",
      remove: "Ta bort",
      confirmRemove: "Ta bort denna beslutsfattare?",
      readerTitle: "Läsning av företagets utrymmen",
      readerSubtitle: "En bot ser bara meddelanden där den nämns. Veridion läser varje meddelande i företagets utrymmen genom auktoriseringen av ett konto som är medlem i alla.",
      notConfigured: "Integrationen är inte konfigurerad",
      authorised: "Auktoriserad",
      notAuthorised: "Inte auktoriserad",
      account: "Konto",
      validUntil: "Åtkomsttoken giltig till",
      renewUntil: "Auktoriseringen kan förnyas till",
      authorise: "Auktorisera läsning",
      authoriseAgain: "Auktorisera igen",
      linkOpened: "Webex-inloggningen öppnades i en ny flik.",
      found: "hittad",
      notFound: "inte hittad",
      botsInSpace: "botar",
      transcripts: "Mötestranskript",
      yes: "ja",
      no: "nej",
      approvalsTitle: "Öppna godkännanden",
      approvalsSubtitle: "Godkännanden och frågor som AI-kollegorna har bett om och som ingen beslutsfattare har besvarat ännu.",
      originSpace: "Utrymme",
      directRoom: "direktsamtal",
      approvalKinds: { review: "godkännande", question: "fråga" },
      schedulesTitle: "Scheman",
      schedulesSubtitle: "Återkommande arbete som någon har bett om i ett utrymme; det körs tills någon avslutar det.",
      createdBy: "beställt av",
      lastRun: "senast körd",
      end: "Avsluta",
      confirmEnd: "Avsluta detta schema?",
      none: "Inga",
      loading: "Laddar…",
      failed: "Misslyckades",
      working: "Pågår…",
      done: "Klart",
      memoryTitle: "Organisation",
      memorySubtitle: "Företagets människor och AI-kollegor med det minnesområde där varje AI-kollega arbetar.",
      memoryMember: "Medlem",
      area: "Område",
      decisionMaker: "Beslutsfattare",
      status: { running: "körs" },
    },
    core: {
      conversationTitle: 'Samtal från instrumentpanelen',
      conversationHint: 'Varje meddelande och varje svar sägs också i Webex: i tråden för agentens arbete, annars i ditt direktrum med boten.',
      conversationEmpty: 'Inget meddelande från instrumentpanelen ännu.',
      writeToAgent: 'Meddelande till den här agenten',
      answerPending: 'Svar väntar',
      title: 'Veridion Core',
      subtitle: 'Det agentiska operativsystemet bakom företagsboten: dess agenter, deras meddelanden och tokenförbrukning, definitionerna, arkitekten och organisationen.',
      done: 'Klart.',
      failed: 'Det fungerade inte',
      loading: 'Laddar …',
      working: 'Arbetar …',
      none: 'Inga.',
      unavailable: 'Veridion Core går inte att nå',
      errors: {
        AGENT_FINISHED: 'Agenten är avslutad och tar inte emot fler meddelanden',
        EMERGENCY_STOP: 'Nödstoppet är aktivt',
        DEFINITION_INVALID: 'Definitionen är inte giltig',
        TOO_MANY_AGENTS: 'För många agenter körs',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core är inte konfigurerat',
        MESSAGE_EMPTY: 'Meddelandet är tomt',
      },
      status: {
        building: 'avbildningen byggs',
        starting: 'startar',
        running: 'körs',
        waiting: 'väntar',
        idle: 'redo',
        paused: 'pausad',
        completed: 'slutförd',
        failed: 'misslyckad',
        cancelled: 'avbruten',
        stopped: 'stoppad',
        not_deployed: 'inte driftsatt',
      },
      statusLabel: 'Status',
      owner: 'Ägare',
      definition: 'Definition',
      parent: 'Föräldraagent',
      tokens: 'Tokens',
      progress: 'Förlopp',
      close: 'Stäng',
      openQuestion: 'Öppen fråga',
      result: 'Resultat',
      answerQuestion: 'Besvara frågan',
      sendMessage: 'Meddelande till agenten',
      urgent: 'Brådskande: avbryt det pågående steget',
      send: 'Skicka',
      messageSent: 'Levererat till agenten.',
      commands: {
        pause: 'Pausa',
        resume: 'Återuppta',
        cancel: 'Avbryt',
        kill: 'Avsluta omedelbart',
      },
      confirmKill: 'Avsluta den här agenten och dess underagenter omedelbart?',
      subAgents: 'Underagenter',
      graph: 'Graf',
      messages: 'Meddelanden',
      messageStatus: {
        queued: 'i kö',
        delivered: 'levererat',
        consumed: 'läst',
        refused: 'avvisat',
      },
      events: 'Händelser',
      containerLog: 'Containerlogg',
      version: 'Version',
      activeAgents: 'Aktiva agenter',
      updated: 'Uppdaterad',
      archived: 'arkiverad',
      noDefinitions: 'Inga definitioner ännu.',
      versions: 'Versioner',
      from: 'från',
      startInput: 'Startindata som JSON',
      agentStarted: 'Agenten har startats.',
      startAgent: 'Starta agent',
      editAsJson: 'Redigera som JSON',
      confirmArchive: 'Arkivera den här definitionen? Agenter som körs fortsätter att köras.',
      archive: 'Arkivera',
      definitionJson: 'Definition som JSON',
      definitionJsonHint: 'En definition i Veridions grafspråk. Validera visar dess brister och dess graf; när den sparas lagras den som en ny godkänd version.',
      checked: 'Kontrollerad.',
      validate: 'Validera',
      saved: 'Sparad som ny version.',
      saveVersion: 'Spara som ny version',
      valid: 'Definitionen är giltig.',
      you: 'Du',
      architect: 'Arkitekt',
      architectPlaceholder: 'Beskriv vad agenten ska göra …',
      newDesign: 'Nytt utkast',
      unitKinds: {
        company: 'företag',
        department: 'avdelning',
        team: 'team',
        project: 'projekt',
      },
      partOf: 'del av',
      confirmRemove: 'Ta bort den här enheten? Dess medlemmar förlorar detta område.',
      remove: 'ta bort',
      addUnit: 'Lägg till en enhet',
      unitId: 'Id (gemener, bindestreck)',
      unitName: 'Namn',
      add: 'Lägg till',
      addMember: 'Lägg till en medlem',
      memberKinds: {
        person: 'person (e-postadress)',
        agent: 'agent (id)',
        definition: 'definition (id)',
      },
      memberId: 'E-postadress eller id',
      role: 'Roll',
      confirmEmergencyOn: 'Stoppa alla agenter nu? Boten fortsätter att svara.',
      confirmEmergencyOff: 'Släppa nödstoppet?',
      emergencyStop: 'Nödstopp',
      emergencyRelease: 'Släpp nödstoppet',
      emergencyActive: 'nödstoppet är aktivt',
      autopilotOn: 'Slå på autopiloten',
      autopilotOff: 'Stäng av autopiloten',
      autopilotActive: 'Autopiloten är aktiv: Veridion Core besvarar själv varje kort till människorna',
      autopilotUnitsTitle: 'Autopilot per affärsenhet',
      autopilotUnitsHint: 'Slår på eller av autopiloten individuellt för varje affärsenhet och den verkställande nivån. Pausat arbete rörs aldrig.',
      autopilotUnitOn: 'Autopilot på',
      autopilotUnitOff: 'Autopilot av',
      limitsBuilds: 'Imagebyggen per kollega och dag',
      limitsDesigns: 'Agentutkast per kollega och dag',
      limitsSave: 'Sätt dagsgränser',
      limitsNone: '0 = ingen gräns',
      confirmAutopilotOn: 'Slå på autopiloten? Veridion Cores egen beslutsfattare besvarar då genast varje öppet och varje nytt kort i pAIoneer-humans-and-bots, synligt i kortets tråd.',
      confirmAutopilotOff: 'Stänga av autopiloten? Därefter beslutar människorna igen.',
      model: 'Modell',
      codingModel: 'Kodningsmodell',
      modelsTitle: 'Modeller per roll',
      modelsSubtitle: 'Vilken modell varje roll i Veridion Core tänker på: företagets ansikte och styrning, telefonen, arkitekten och domaren över kravdomarna. Endast modeller som gatewayen routar kan väljas; tomt betyder konfigurationens standard.',
      roleCoordinator: 'Koordinator (ansikte och styrning)',
      roleCall: 'Telefon',
      roleArchitect: 'Arkitekt',
      roleRequirementsJudge: 'Kravdomare',
      roleJudge: 'Corens bedömningar',
      roleEar: 'Telefonöra',
      roleStt: 'Webex-öra',
      modelGroupVllm: 'vLLM (eget kort)',
      modelGroupAudio: 'Ljud (eget kort / moln)',
      modelGroupCloud: 'OpenRouter (moln)',
      directLlmTitle: 'Direkt LLM-åtkomst',
      directLlmSubtitle: 'Prata direkt med en vLLM eller molnmodell, utan bottar, agenter eller Webex',
      directLlmHint: 'Administratörens direktåtkomst: den valda modellen svarar rått, bokförd som ”console”, utan lanes, roller eller verktyg.',
      directLlmModel: 'Modell',
      directLlmSystem: 'Systemprompt (valfritt)',
      directLlmSystemPlaceholder: 't.ex. Du är …',
      directLlmPrompt: 'Meddelande',
      directLlmPromptPlaceholder: 'Vad vill du fråga modellen direkt?',
      directLlmSend: 'Skicka',
      directLlmSending: 'Skickar …',
      directLlmUsage: '{prompt}+{completion} tokens · {cost}',
      modelCurrent: 'I bruk',
      modelDefault: 'Standard',
      modelChosen: 'Vald',
      modelDefaultOption: 'konfigurationens standard',
      modelNotRouted: 'routas inte av gatewayen',
      modelSave: 'Spara',
      engineSilver: 'Företagets motor (silver)',
      engineGold: 'Företagets motor (guld, orkestratorns)',
      callsTitle: 'Telefonsamtal',
      callsSubtitle: 'Varje talad tur i telefonen, bokförd skilt från kollegornas arbete: tokens, kostnad och tiden för öra, tanke och röst, per kollega och modell, för de senaste 30 dagarna och idag; nedan de nyaste turerna.',
      callsTurns: 'Turer',
      callsCalls: 'Samtal',
      callsAvgTotal: 'Ø totalt ms',
      callsAvgAsr: 'Ø öra ms',
      callsAvgLlm: 'Ø tanke ms',
      callsAvgTts: 'Ø röst ms',
      callsDeferred: 'Uppskjutna',
      callsToday: 'Idag',
      callsWindow: 'Senaste 30 dagarna',
      callsRecent: 'Nyaste turerna',
      callsPerson: 'Person',
      callsRounds: 'Rundor',
      callsNone: 'Inget samtal bokfört ännu.',
      unitKindExecutive: 'Ledningsnivå',
      unitKindBusinessUnit: 'Affärsenhet',
      orgSynced: 'Ledningsnivån och affärsenheterna definieras i Veridion Cores organisation och synkroniseras hit; de ändras där, inte på den här sidan.',
      memory: 'Minne',
      ready: 'redo',
      notReady: 'inte redo',
      factExtraction: 'faktaextraktion aktiv',
      cluster: 'Klusteråtkomst',
      agentsRunning: 'Agenter som körs',
      agentsWaiting: 'väntar',
      definitions: 'Definitioner',
      gatewayIdentity: 'Gateway-identitet',
      gatewayTokens: 'Gateway-tokens i tidsfönstret',
      hostedTitle: 'Värdade agenter',
      hostedSubtitle: 'AI-applikationer som Veridion Core startar och driver i egna containrar.',
      agent: 'Agent',
      actions: 'Åtgärder',
      confirmHosted: '{action}: {agent}?',
      hostedActions: {
        start: 'starta',
        stop: 'stoppa',
        restart: 'starta om',
      },
      open: 'öppna',
      agentsTitle: 'Agenter',
      agentsSubtitle: 'Varje agent och underagent körs i en egen container. Öppna en för att skicka meddelanden till den eller styra den.',
      showFinished: 'Visa avslutade agenter',
      noAgents: 'Inga agenter.',
      definitionsTitle: 'Definitioner',
      definitionsSubtitle: 'Godkända agentgrafer med sina versioner.',
      designsTitle: 'Agentutkast',
      designsSubtitle: 'Varje agent som arkitekten har utformat, för en person eller för en AI-kollegas arbete: vad för och varför, varje fråga med svar, testkörningarna mot scenarierna, godkännandet och körningarna.',
      design: 'Utkast',
      designFor: 'För',
      designWork: 'Arbete',
      designState: 'Status',
      designApprovedBy: 'Godkänd av',
      designAgent: 'Byggd agent',
      filterState: 'Status',
      filterAll: 'Alla',
      filterOpen: 'Öppna',
      filterDone: 'Klara',
      filterFailed: 'Misslyckade',
      filterCurrent: 'Aktiva och nyligen misslyckade',
      filterActive: 'Aktiva',
      filterFinished: 'Avslutade',
      filterPosition: 'AI-kollega',
      pagePrev: 'Föregående',
      pageNext: 'Nästa',
      pageLabel: 'Sida',
      searchLabel: 'Sök',
      showMore: 'Visa fler',
      noDesigns: 'Ingen agent utformad ännu.',
      designReason: 'Varför verktygen inte räckte',
      designRecord: 'Förlopp',
      designAgents: 'Utkastets agenter',
      designTestRun: 'Testkörning',
      designRun: 'Körning',
      designStatus: { designing: 'utformas', testing: 'testas', asking: 'väntar på svar', approval: 'väntar på godkännande', running: 'körs', done: 'klar', failed: 'misslyckad', cancelled: 'avbruten' },
      builtBy: 'Byggd av',
      builtFor: 'För arbetet',
      viaCodingTask: 'via kodagenten',
      designTests: 'Testkörningar',
      designRuns: 'Körningar',
      designByPerson: 'en person i samtal',
      diagramsTitle: 'Diagram',
      diagramsSubtitle: 'Bilder av flöden, arkitekturer och planer som AI-kollegor, agenter och kodagenten ritat, med titel, teckenförklaring och Mermaid-kod.',
      noDiagrams: 'Inget diagram ännu.',
      diagramAuthor: 'Författare',
      diagramBasedOn: 'Bygger på',
      diagramCode: 'Mermaid-kod',
      architectTitle: 'Arkitekt',
      architectSubtitle: 'Utforma en agent i dialog. Arkitekten frågar om det den inte kan avgöra själv och skapar agenten först efter ditt godkännande.',
      orgTitle: 'Organisation',
      orgSubtitle: 'Avdelningar, team och projekt med sina medlemmar; företagsminnet delas längs denna struktur.',
      usageTitle: 'Förbrukning per agent',
      usageSubtitle: 'Modellanrop, tokens och rapporterade kostnader för de senaste 30 dagarna.',
      calls: 'Anrop',
      source: 'Källa',
      gpuTokens: 'Tokens på grafikkortet',
      cloudTokens: 'Tokens i molnet',
      usageByModel: 'Per kollega och modell',
      cost: 'Kostnad',
    },
    memory: {
      archOverviewTitle: "Arkitekturöversikt: hur företagsminnet är uppbyggt",
      archOverviewText: "Veridion Core lagrar företagets kunskap i tre skikt: Neo4j som tidsmedveten kunskapsgraf för fakta, beslut och arbetspaket, PostgreSQL för transaktionella agent-, brevlåde- och sprinttillstånd samt Qdrant för vektorsökning över företagsdokument. Varje affärsenhet arbetar i en fackligt isolerad kunskapsdomän; resultat mellan enheter går via protokollförda överlämningar.",
      clustersTitle: "Affärsenheternas kunskapsdomäner",
      clustersSubtitle: "Varje affärsenhet arbetar i en avgränsad Neo4j-kunskapsdomän; nod- och kantantal kommer live från Neo4j, beskrivningarna från den markerade första påfyllningen. Ett klick öppnar domänen i kunskapsgrafen.",
      clusterCode: "Kod",
      clusterName: "Kunskapsdomän",
      clusterId: "Identitet",
      clusterRoles: "Roller",
      clusterBridges: "Överlämningsbryggor",
      clusterPolicy: "Fackligt fokus & isoleringsregel",
      clusterCounts: "Noder / kanter (live)",
      clusterInsights: "Insikter (första påfyllning)",
      clusterOpenButton: "Öppna i kunskapsgrafen",
      countsUnavailable: "Neo4j kan inte nås — ingen räkning",
      researchTitle: "Forskningsarkiv för kvant- & frontier-AI",
      researchSubtitle: "Vetenskapliga nyckelpublikationer & arkitekturreferenser — live-rader från Veridion Core; varje rads ursprung är synligt.",
      researchEmpty: "Ingen publikation i arkivet ännu.",
      researchIngestNote: "Nya publikationer läggs till av kvantkollegan via dess verktyg; instrumentpanelen läser bara arkivet.",
      researchPublication: "Publikation",
      researchMechanism: "Nyckelmekanism",
      researchRelevance: "Relevans för arkitekturen",
      researchOrigin: "Ursprung",
      researchSeeded: "första påfyllning",
      researchMotivates: "Motiverar version",
      title: 'Företagsminne',
      subtitle: 'Vad Veridion Core lagrar i Neo4j: minnen per område, fakta med sin giltighetstid och granskningsloggen över vad agenterna har gjort.',
      failed: 'Det fungerade inte',
      loading: 'Laddar …',
      unavailable: 'Minnet går inte att nå',
      database: 'Databas',
      ready: 'redo',
      notReady: 'inte redo',
      factExtraction: 'Faktaextraktion',
      episodesQueued: 'Väntande episoder',
      lastError: 'Senaste fel',
      contentTitle: 'Innehåll',
      contentSubtitle: 'Noder per etikett och minnen per område och typ.',
      label: 'Etikett',
      count: 'Antal',
      empty: 'Inget ännu.',
      scope: 'Område',
      kind: 'Typ',
      kinds: {
        fact: 'fakta',
        decision: 'beslut',
        task: 'uppgift',
        procedure: 'tillvägagångssätt',
        note: 'anteckning',
        episode: 'episod',
      },
      searchTitle: 'Sök',
      searchSubtitle: 'Hämtningen som agenterna använder: betydelse, ord och extraherade fakta.',
      searchPlaceholder: 'Sökterm eller fråga',
      allScopes: 'alla områden',
      search: 'Sök',
      noResults: 'Inget hittades.',
      text: 'Text',
      validFrom: 'Giltig från',
      source: 'Källa',
      extracted: 'extraherad',
      recorded: 'registrerad',
      rememberTitle: 'Spara i minnet',
      rememberSubtitle: 'Lagra ett faktum, ett beslut, en uppgift, ett tillvägagångssätt eller en anteckning i ett område.',
      remembered: 'Sparat.',
      remember: 'Spara',
      created: 'Skapad',
      validity: 'Giltighet',
      invalid: 'ogiltig',
      confirmInvalidate: 'Markera detta minne som inte längre giltigt?',
      invalidate: 'markera som ogiltig',
      forget: 'glöm',
      confirmForget: 'Glömma denna post för gott? Den raderas ur minnet och kan inte återställas.',
      forgotten: 'Glömd.',
      factsTitle: 'Fakta över tid',
      factsSubtitle: 'Fakta som extraherats ur samtal och agentresultat; ett motsagt faktum får ett slutdatum.',
      noFacts: 'Inga fakta extraherade ännu.',
      briefsTitle: 'AI-kollegornas lägesbilder',
      briefsSubtitle: 'Det varje AI-kollega läser först: öppna åtaganden, gällande beslut, pågående ärenden och kunder, skrivet varje natt ur minnet.',
      brief: 'Lägesbild',
      updated: 'Uppdaterad',
      noBriefs: 'Inga lägesbilder skrivna ännu.',
      fact: 'Faktum',
      from: 'Från',
      to: 'Till',
      validUntil: 'Giltig till',
      stillValid: 'fortfarande giltig',
      entityTitle: 'Närområde',
      entitySubtitle: 'Vad en uppgift, ett projekt, en person, ett system eller en entitet är kopplad till.',
      entityPlaceholder: 'Namn, uppgifts-id, e-postadress eller id',
      show: 'Visa',
      auditTitle: 'Granskningslogg',
      auditSubtitle: 'Agenternas modell- och verktygsanrop, meddelanden och startade underagenter.',
      auditPlaceholder: 'Agent-id (tomt: alla)',
      filter: 'Filtrera',
      time: 'Tid',
      agent: 'Agent',
      event: 'Händelse',
      toolOrModel: 'Verktyg eller modell',
      status: 'Status',
      detail: 'Detalj',
      consoleTitle: 'Frågekonsol',
      consoleSubtitle: 'Endast läsande Cypher; skrivande satser avvisas.',
      run: 'Kör',
      truncated: 'fler rader klipptes bort',
      graph: {
        clusterPickTitle: "Fokusera en kunskapsdomän i grafen",
        clusterPickHint: "Ett klick på en affärsenhet fokuserar dess delgraf med roller och överlämningsbryggor i den interaktiva grafen.",
        allClusters: "Alla domäner (hela grafen)",
        activeCluster: "Aktiv kunskapsdomän",
        publicationsTitle: "Publikationer i forskningsarkivet",
        storesTitle: 'Företagsminnets lager',
        storesSubtitle: 'Vad varje lager i företagsminnet håller, läst live: grafen i Neo4j, Veridion Cores tillstånd i Postgres, kunskapsbasens vektorer i Qdrant.',
        storeNeo4j: 'Neo4j (graf)',
        storeNeo4jHolds: 'Företagsminnet: minnen med sitt område, de entiteter och fakta Graphiti har extraherat med sin giltighetstid, arbetsposterna med sin mening, programvaruarbetet och agenternas revision.',
        storePostgres: 'Postgres (relationell)',
        storePostgresHolds: 'Veridion Cores transaktionella tillstånd: agenternas processtabell, brevlådor, samtal, kontrollpunkter, kodningsuppgifter, godkännanden, organisationen och förbrukningen.',
        storeQdrant: 'Qdrant (vektorer)',
        storeQdrantHolds: 'Företagets kunskapsbas: de inbäddade avsnitten av dokument som en administratör lagt till, sökta av orkestreraren när en samtalstur behöver kunskapsbasen.',
        nodes: 'noder',
        relationships: 'relationer',
        relationshipType: 'Relationstyp',
        tables: 'tabeller',
        table: 'Tabell',
        rows: 'rader',
        purpose: 'Vad den håller',
        documents: 'dokument',
        session: 'Session',
        collection: 'Samling',
        role: 'Roll',
        roleDocuments: 'dokument',
        roleCurated: 'granskade fråga-svar-par',
        title: 'Graf',
        subtitle: 'Företagsminnets graf i Neo4j: börja från en sökträff, de nyaste minnena eller arbetsposterna; klicka på en nod för att läsa den, expandera dess grannar, dra för att ordna, rulla för att zooma.',
        startNewest: 'Nyaste minnen',
        startWork: 'Arbetsposter',
        searchPlaceholder: 'Namn, text eller id att hitta i grafen',
        find: 'Sök',
        noHits: 'Inget hittat.',
        name: 'Namn',
        sources: { memory: 'minne', entity: 'extraherad entitet', node: 'projektminne', episode: 'episod' },
        show: 'visa',
        shown: '{nodes} noder och {edges} relationer i grafen',
        truncated: 'avklippt vid gränsen; expandera en nod eller sök snävare',
        selected: 'Vald nod',
        selectHint: 'Klicka på en nod i grafen.',
        expand: 'Expandera grannar',
        expandTwo: 'Expandera två nivåer',
        centre: 'Centrera på denna nod',
        facts: 'Fakta om denna entitet',
        degree: 'Relationer',
        direction: 'Riktning',
        out: 'utgående',
        in: 'inkommande',
        noRelationships: 'Inga relationer.',
        property: 'Egenskap',
        value: 'Värde',
        noProperties: 'Inga egenskaper.',
        factsOf: 'Fakta om',
        factsSubtitle: 'Vad Graphiti har extraherat om denna entitet, med tiden varje faktum gäller; ett motsagt faktum bär ett slutdatum.',
        relation: 'Relation',
        other: 'Annan entitet',
        newestTitle: 'Nyaste minnen',
        newestSubtitle: 'De senast skrivna minnena, med vad vart och ett handlar om; ”visa” ritar ett med dess länkar.',
        about: 'Handlar om',
        workTitle: 'Arbetsposter',
        workSubtitle: 'Varje bekräftat arbete med tillstånd, ansvarig, ärende och resultaten av dess scenarier; ”visa” ritar ett med dess mening, ärende, kodningsuppgifter och de agenter som byggts för det.',
        allStates: 'alla tillstånd',
        states: { confirmed: 'bekräftad', in_progress: 'pågår', blocked: 'blockerad', done: 'klar', failed: 'misslyckad', dropped: 'avförd' },
        workItem: 'Arbetspost',
        owner: 'Ansvarig',
        issue: 'Ärende',
        scenarios: 'Scenarier',
        results: { passed: 'godkänt', failed: 'misslyckat', pending: 'väntar' },
      },
      day: {
        title: 'Företagets dag',
        subtitle: 'Tidslinjen över de händelser Veridion Core antecknar: människornas ord, kort, arbete, överlämningar, efterforskningar, agenter, kodningsuppgifter, projekt, incidenter och möten, nyast först.',
        sinceToday: 'i dag',
        sinceDay: 'senaste 24 timmarna',
        sinceWeek: 'senaste 7 dagarna',
        allKinds: 'alla slag',
        refresh: 'Uppdatera',
        count: '{n} händelser',
        time: 'Tid',
        actor: 'Aktör',
        happening: 'Händelse',
        work: 'Arbete',
        empty: 'Inget antecknat i detta fönster.',
        kinds: { word: 'ord', request: 'begäran', card: 'kort', work: 'arbete', handover: 'överlämning', research: 'efterforskning', agent: 'agent', task: 'kodningsuppgift', project: 'projekt', incident: 'incident', schedule: 'schema', meeting: 'möte', message: 'meddelande' },
      },
    },
    title: 'Administrationspanel',
    adminKicker: 'Drift',
    smtmStatusTitle: 'SMTM-data och prognoser',
    smtmStatusSubtitle: 'Övervakar mäklarens tidsserier, publicerade modeller, prognosutdata och RSS-flöden.',
    smtmStatusUnavailable: 'SMTM-status inte tillgänglig',
    smtmGeneratedAt: 'Genererad',
    smtmMinimumRows: 'Minsta antal träningsrader',
    smtmBaseFrames: 'Bastidsserier',
    smtmTrainableFrames: 'Rådata klara',
    smtmWaitingHistory: 'Väntar på historik',
    smtmPredictionTrackedInstruments: 'Bevakade instrument',
    smtmPredictionEnabledCount: 'Prognoser aktiva',
    smtmPredictionDisabledCount: 'Prognoser pausade',
    smtmMlFrames: 'ML-datamängder',
    smtmOnlineModels: 'Modeller online',
    smtmModelsWithArtifacts: 'Modeller med artefakter',
    smtmPredictionFrames: 'Prognosserier',
    smtmMissingPredictions: 'Serier utan prognoser',
    smtmBlobArtifacts: 'Blob-artefakter',
    smtmStalePredictions: 'Föråldrade prognoser',
    smtmRssFrames: 'RSS-flöden',
    smtmDataframesTotal: 'Datamängder totalt',
    smtmLatestModelUpload: 'Senaste modelluppladdning',
    smtmLatestPredictionWrite: 'Senaste prognosskrivning',
    smtmRuntimeHints: 'Driftanmärkningar',
    smtmNoHints: 'Inga öppna SMTM-anmärkningar.',
    smtmInstrument: 'Instrument',
    smtmBaseData: 'Basdata',
    smtmMlFrame: 'ML-datamängd',
    smtmModelPublish: 'Modellstatus',
    smtmArtifacts: 'Artefakter',
    smtmPredictionFrame: 'Prognosserie',
    smtmIssues: 'Problem',
    smtmNoIssues: 'Inga problem',
    smtmNoFrames: 'Inga SMTM-instrument hittades.',
    smtmPredictionControlTitle: 'SMTM-prognosstyrning',
    smtmPredictionControlSubtitle: 'Bestäm per instrument om SMTM ska beräkna nya maskininlärningsprognoser eller bara fortsätta samla basdata.',
    smtmPredictionSettingsUnavailable: 'SMTM-prognosstyrning inte tillgänglig',
    smtmPredictionControlHint: 'Pausade instrument behåller sin historik. Nya ML-datamängder, träningar och prognoser skapas inte längre för dem.',
    smtmPredictionMode: 'Prognosläge',
    smtmPredictionToggle: 'Administratörsstyrning',
    smtmPredictionToggleLabel: 'Aktivera eller pausa prognoser',
    smtmPredictionEnabled: 'Prognos aktiv',
    smtmPredictionDisabled: 'Prognos pausad',
    smtmPredictionSaving: 'Sparar...',
    smtmPredictionSettingsSaved: 'SMTM-prognosstyrning sparad.',
    smtmPredictionSaveChanges: 'Spara ändringar',
    smtmPredictionResetChanges: 'Kasta ändringar',
    smtmPredictionPendingChanges: 'väntande ändringar',
    smtmPredictionPendingBadge: 'Väntar på att sparas',
    smtmOpenAzuriteUi: 'Öppna Azurites webbgränssnitt',
    azuriteTitle: 'Azurites webbgränssnitt (SMTM)',
    azuriteSubtitle: 'Skrivskyddad vy över modelstatus-poster, blob-artefakter och modellnedladdningar.',
    azuriteModelGroups: 'Modellgrupper',
    azuriteBlobArtifacts: 'Blob-artefakter',
    azuriteFiles: 'Filer',
    azuriteSearchPlaceholder: 'Filtrera modeller',
    azuriteNoModels: 'Inga Azurite-modeller hittades.',
    smtmRows: 'Rader',
    smtmLatest: 'Senaste tidsstämpel',
    smtmAge: 'Ålder',
    smtmValue: 'Värde',
    smtmMinutesAgo: 'min sedan',
    smtmMinutesAhead: 'min framåt',
    smtmHoursAgo: 'tim sedan',
    smtmDaysAgo: 'dgr sedan',
    smtmStateLabels: {
      available: 'Tillgänglig',
      trainable: 'Träningsbar',
      waiting_for_history: 'Väntar på historik',
      missing_base_data: 'Inga basdata',
      missing_machine_learning: 'ML-datamängd saknas',
      missing_prediction: 'Prognos saknas',
      prediction_disabled: 'Prognos pausad',
      stale_prediction: 'Föråldrad prognos',
      open: 'Öppen',
      completed: 'Slutförd',
      online: 'Online',
      offline: 'Offline',
      training: 'Tränar',
      uploading: 'Laddar upp',
      failed: 'Misslyckad',
      unknown: 'Okänd',
      missing: 'Saknas'
    },
    smtmIssueLabels: {
      empty_base_frame: 'Bastidsserien är tom',
      insufficient_history: 'För lite historik',
      missing_machine_learning_frame: 'ML-datamängd saknas',
      missing_prediction_frame: 'Prognosserie saknas',
      stale_prediction_frame: 'Prognosserien är föråldrad',
      missing_online_model: 'Ingen modell online',
      model_offline: 'Modellen är offline',
      missing_model_blob: 'Modellblob saknas',
      missing_model_header: 'Modellhuvud saknas',
      missing_modelstatus_entry: 'Modelstatus-post saknas',
      inference_not_writing_prediction: 'Inferensen skriver inga prognoser',
      prediction_disabled_by_admin: 'Prognos pausad av administratören'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: 'instrument med färdiga rådata utan prognosutdata',
      instruments_waiting_for_history: 'instrument som fortfarande väntar på historik',
      models_missing_artifacts: 'modeller online utan fullständiga artefakter',
      no_online_models: 'Inga modeller online i Azurite',
      azurite_unavailable: 'Azurites lagringsstatus är för närvarande inte tillgänglig'
    },
    mailTitle: 'E-postkonfiguration',
    usersTitle: 'Användarhantering',
    usersSubtitle: 'Konton, roller, status och 2FA från Keycloak. Väljer du ett konto öppnas kontrollerna för just det kontot.',
    usersHideCreate: 'Stäng formuläret',
    usersCreateHint: 'Ett nytt konto börjar med obligatorisk 2FA och blir aktivt så snart den är inställd.',
    usersFilterAllStatus: 'Alla tillstånd',
    usersFilterAllRoles: 'Alla roller',
    usersManage: 'Hantera',
    usersClose: 'Stäng',
    usersNoneFound: 'Inga användare hittades.',
    usersPagePrev: 'Föregående',
    usersPageNext: 'Nästa',
    auditTitle: 'Granskningslogg',
    smtpHost: 'SMTP-värd',
    smtpPort: 'SMTP-port',
    smtpSecurity: 'SMTP-säkerhet',
    smtpUsername: 'SMTP-användare',
    smtpPassword: 'SMTP-lösenord',
    fromEmail: 'Avsändaradress',
    fromName: 'Avsändarnamn',
    replyToEmail: 'Svarsadress',
    saveMailSettings: 'Spara e-postinställningar',
    sendTestMail: 'Skicka testmeddelande',
    createUser: 'Skapa användare',
    setPassword: 'Ange lösenord',
    setRoles: 'Ange roller',
    setStatus: 'Ange status',
    resetMfa: 'Återställ 2FA',
    revokeSessions: 'Återkalla sessioner',
    filterUsers: 'Filtrera användare',
    testRecipient: 'Mottagare av testmeddelande',
    statusConfigured: 'Konfigurerad',
    statusMissing: 'Inte konfigurerad',
    userEmail: 'E-post',
    userName: 'Användarnamn',
    userRoles: 'Roller',
    userStatus: 'Status',
    auditEvent: 'Händelse',
    auditCreatedAt: 'Skapad',
    auditDetails: 'Detaljer',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'Slutpunkt',
    aiGatewayIdentitySource: 'Identitet från tokenanspråk',
    aiGatewayBudgetSource: 'Startvärden i',
    aiGatewayModels: 'Routade modeller',
    aiGatewayModel: 'Modell',
    aiGatewayBackend: 'Backend',
    aiGatewayBudgets: 'Tokenbudgetar',
    aiGatewayIdentity: 'Identitet',
    aiGatewayTokenBudget: 'Tokenbudget',
    aiGatewayWindow: 'Fönster',
    aiGatewayAnyIdentity: 'valfri identitet',
    aiGatewayAnyModel: 'valfri modell',
    aiUsageWindowStarted: 'Fönster sedan',
    aiUsageRemaining: 'Återstår',
    aiUsageIdentities: 'Identiteter',
    aiGatewaySubtitle: 'Envoy AI Gateway är enda vägen till en modell: de routade modellerna, deras servande backends och varje identitets tokenbudget.',
    aiGatewayHint: 'Budgetarna sköts här. Distributionslagret sätter bara startvärdena för ett nytt kluster.',
    aiUsageTitle: 'AI-förbrukning per identitet',
    aiUsageSubtitle: 'Tokens som gatewayen bokfört i det pågående fönstret.',
    sessionActiveUsers: 'Inloggade användare',
    sessionActiveSessions: 'Aktiva sessioner',
    sessionMfaSessions: 'Verifierade sessioner',
    aiUsageTotalTokens: 'Tokens totalt',
    aiServicesTitle: 'Tjänsteåtkomst',
    aiServicesSubtitle: 'Länkar till plattformens API- och driftgränssnitt; varje mål kontrollerar själv adminrollen.',
    aiMailSubtitle: 'SMTP-inställningarna som Keycloak skickar verifierings- och återställningsmejl med, samt testutskicket.',
    tabOverview: 'Översikt',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'E-postutskick',
    tabUsers: 'Användare',
    tabAudit: 'Revisionslogg',
    tabServiceLinks: 'Tjänsteåtkomst',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'Plattform',
    platformTitle: 'Plattformens tillstånd',
    platformSubtitle: 'Varje pAIoneer Labs GmbH-arbetslast med klara repliker, omstarter och avbild, direkt från Kubernetes.',
    platformHostPage: 'Hantera instanser i appvärden',
    openVisitorMonitoring: 'Öppna besöks-, marknadsförings- & SEO-övervakning',
    platformUnavailable: 'Plattformens tillstånd inte tillgängligt',
    platformWorkloadsTotal: 'Arbetslaster',
    platformDegradedTotal: 'Inte klara',
    platformRestartsTotal: 'Omstarter',
    platformWorkload: 'Arbetslast',
    platformNamespace: 'Namnrymd',
    platformReplicas: 'Repliker',
    platformRestarts: 'Omstarter',
    platformImage: 'Avbild',
    platformState: 'Tillstånd',
    platformStateReady: 'Klar',
    platformStateDegraded: 'Försämrad',
    platformStateDown: 'Nere',
    platformStateUnknown: 'Okänt',
    platformNodes: 'Noder',
    platformOsImage: 'Operativsystem',
    platformKernel: 'Kärna',
    platformRuntime: 'Containerruntime',
    platformKubelet: 'Kubelet',
    platformUsed: 'Används nu',
    platformReportedCapacity: 'Rapporterat av Kubernetes',
    platformConfiguredCap: 'Konfigurerat containertak',
    platformPressure: 'Tryckvillkor',
    platformPressureNone: 'inga',
    platformCpu: 'CPU-kärnor',
    platformNoWorkloads: 'Denna namnrymd innehåller konfigurationsobjekt, inga arbetslaster.',
    platformMemory: 'Minne',
    platformEvents: 'Senaste varningar',
    platformEventsNone: 'Inga varningar.',
    platformEventObject: 'Objekt',
    platformEventReason: 'Orsak',
    platformEventMessage: 'Meddelande',
    platformEventLastSeen: 'Senast sedd',
    platformMetricsMissing: 'Inga förbrukningsdata: metrics-server svarar inte.',
    aiGatewayBackends: 'Servande backends',
    gpuTitle: 'Grafikkort',
    gpuNote: 'Belastningen på grafikkortets motorer, de tokens som tagits från dem per identitet och per Webex-bot samt tokenbudgetarna per identitet och motor.',
    gpuTokensWindow: 'Tokens på grafikkortet i fönstret',
    gpuSinceStart: 'sedan motorn startade',
    gpuIdentities: 'Per identitet, pågående fönster',
    gpuBots: 'Per Webex-bot och agent, 30 dagar',
    gpuBot: 'Webex-bot / agent',
    gpuBudgetTitle: 'Budget per identitet för motorn',
    gpuBudgetSet: 'Sätt budget',
    gpuBudgetHint: 'Tokens per timme på motorn; gatewayen upprätthåller den. Den begränsar även en identitet utan gräns.',
    gpuNoneYet: 'Inget bokfört ännu.',
    gpuEngines: 'Motorer',
    gpuEngine: 'Motor',
    gpuEngineGold: 'Guldmotorn',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Körmiljö, kunskapsbas, träningsförberedelse och spårbarhet för Agentic RAG-applikationen.',
    agenticRagBackendStatus: 'Backend-status',
    agenticRagRuntimeMode: 'Körläge',
    agenticRagKnowledgeMode: 'Kunskapsläge',
    agenticRagDeploymentEnv: 'Driftsättningsmiljö',
    agenticRagVectorStores: 'Vektorlager',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'Dokumentsamling',
    agenticRagQdrantCuratedCollection: 'Samling av kurerade frågor och svar',
    agenticRagQdrantDashboard: 'Instrumentpanel',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Öppna Swagger',
    agenticRagOpenPhoenix: 'Öppna Phoenix',
    agenticRagOpenQdrant: 'Öppna Qdrant',
    agenticRagKnowledgeTitle: 'Kunskapsbas',
    agenticRagKnowledgeSubtitle: 'Status för dokumenten och de kurerade frågorna och svaren i Agentic RAG-applikationen.',
    agenticRagDocuments: 'Dokument',
    agenticRagCuratedQaPairs: 'Kurerade fråga-svar-par',
    agenticRagTrainingTitle: 'Träningsförberedelse',
    agenticRagTrainingSubtitle: 'Den senaste generatorkörningen och tränarens senaste status.',
    agenticRagLatestDataset: 'Senaste datamängd',
    agenticRagDatasetPairs: 'Fråga-svar-par',
    agenticRagDatasetDocuments: 'Bearbetade dokument',
    agenticRagDatasetModifiedAt: 'Senast ändrad',
    agenticRagLatestTrainerInput: 'Senaste tränarindata',
    agenticRagTrainerInputModifiedAt: 'Indata ändrad',
    agenticRagLatestTrainerRun: 'Senaste tränarkörning',
    agenticRagTrainerRunModifiedAt: 'Körningssammanfattning ändrad',
    gpuEngineSilver: 'Silvermotorn',
    gpuAssignment: 'Tilldelning',
    gpuWho: 'Vem',
    gpuRank: 'Rang',
    gpuRankHint: 'Rang 0 betjänas först; varje motor betjänar efter rang.',
    gpuLanes: 'Pågående anrop från Veridion Core per motor och rang',
    gpuInFlight: 'pågående',
    gpuWhoMainBotPeople: 'Huvudboten: samtal med människor',
    gpuWhoMainBotJudgements: 'Huvudboten: bedömningar i samma tur',
    gpuWhoAutopilot: 'Autopilot',
    gpuWhoAgents: 'Agenter som huvudboten kör',
    gpuWhoArchitect: 'Arkitekt',
    gpuWhoChair: 'Mötesordförande',
    gpuWhoOrchestrator: 'Orkestrator för företagsinstansen',
    gpuWhoColleagues: 'AI-kollegorna: turer och deras bedömningar',
    gpuWhoMeetingWords: 'AI-kollegorna: mötesinlägg',
    gpuWhoBackgroundReading: 'Bakgrundstjänst: läsning av botarnas inlägg',
    gpuWhoMemory: 'Företagsminnet: intagning och briefer',
    gpuWhoCoding: 'Kodningsuppgifter: bedömningar och lärande',
    gpuWhoResearch: 'Webb- och OSINT-efterforskning',
    gpuWhoKnowledgeBase: 'Företagets kunskapsbas: läsning av skannade sidor',
    gpuWhoPipeline: 'Pipelinegranskning mot IDD',
    gpuWhoSmtm: 'Veridion SMTM: SaaS-chatten och kunskapsbasen, sista rang',
    gpuUnavailable: 'Grafikkortet svarar inte',
    aiGatewaySource: 'Källa',
    aiSourceGpu: 'Grafikkort',
    aiGatewayMeter: 'Mätare',
    aiGatewayMeterIdentity: 'Varje identitet, räknad',
    aiGatewayEngines: 'Motorer på grafikkortet',
    aiGatewayEnginesHint: 'Livesiffror för varje motor ur dess mätvärden: pågående och väntande förfrågningar, cacheanvändning och antalet tokens som betjänats sedan starten.',
    aiEngineRunning: 'Pågår',
    aiEngineWaiting: 'Väntar',
    aiEngineCache: 'Cache använd',
    aiEngineServed: 'Tokens betjänade',
    aiEngineIdle: 'Inga förfrågningar',
    aiEngineUnavailable: 'Motorn svarar inte',
    aiGatewayServing: 'Klar',
    aiBudgetControlTitle: 'Sköt tokenbudgetar',
    aiBudgetControlSubtitle: 'Standardbudgeten gäller varje identitet. En enskild identitet kan få ett eget tak.',
    aiBudgetDefault: 'Standardbudget',
    aiBudgetIdentity: 'Identitet',
    aiBudgetTokens: 'Tokens',
    aiBudgetApply: 'Tillämpa',
    aiBudgetAdd: 'Sätt tak',
    aiBudgetRemove: 'Ta bort',
    aiBudgetSaved: 'Tokenbudget tillämpad.',
    aiBudgetIdentityPlaceholder: 'Klient-id, t.ex. paioneer-agent-veridion-smtm',
    aiBudgetUnlimited: 'Ingen gräns',
    aiBudgetSetUnlimited: 'Ta bort gränsen',
    aiBudgetRestoreLimit: 'Återställ gränsen',
    aiUsageReset: 'Töm fönstret',
    aiUsageResetDone: 'Pågående fönster tömt.',
    userMfa: '2FA',
    userMfaOn: 'Konfigurerad',
    userMfaOff: 'Saknas',
    userCreatedAt: 'Skapad',
    mailSource: 'Hanteras i',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: 'Konversationskärnan i handelsassistenten: körmiljö, verktygsregister, MCP-servrar och aktivitet.',
    veridionOpenPage: 'Öppna Veridion',
    veridionOpenDocs: 'Öppna Swagger',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'Verktyg',
    veridionToolsTitle: 'Verktygsregister',
    veridionToolsSubtitle: 'Visar de laddade verktygsfamiljerna och deras faktiska tillstånd.',
    veridionToolName: 'Verktyg',
    veridionToolRuntime: 'Runtime',
    veridionToolRisk: 'Risk',
    veridionToolEnabled: 'Aktiverat',
    veridionNoTools: 'Inga Veridion-verktyg är laddade.',
    veridionRuntimeProfiles: 'Runtime-profiler',
    veridionRegistryReloaded: 'Registret omladdat',
    veridionProvider: 'AI-väg',
    veridionMcpTitle: 'MCP-servrar',
    veridionMcpSubtitle: 'Anslutna externa verktygsservrar med status och antal verktyg.',
    veridionMcpServer: 'Server',
    veridionMcpState: 'Status',
    veridionMcpTools: 'Verktyg',
    veridionMcpLastSuccess: 'Senast nådd',
    veridionMcpConnected: 'ansluten',
    veridionMcpUnreachable: 'onåbar',
    veridionMcpDisabled: 'avstängd',
    veridionMcpEmpty: 'Inga MCP-servrar konfigurerade.',
    veridionActivityTitle: 'Aktivitetsflöde',
    veridionActivitySubtitle: 'Strukturerade körhändelser från orkestreraren och dess verktyg.',
    veridionActivityEmpty: 'Ingen aktivitet registrerad ännu.',
    veridionActivitySource: 'Källa',
    veridionActivitySurface: 'Yta',
    veridionActivityEvent: 'Händelse',
    veridionActivityTool: 'Verktyg',
    veridionActivityStatus: 'Status',
    veridionActivitySummary: 'Sammanfattning',
    veridionUnavailable: 'Veridion är för närvarande inte tillgängligt.',
    veridionNotConfigured: 'Veridion är ännu inte fullständigt konfigurerat i Homepage-runtime.',
    veridionRequestFailed: 'Veridion slutförde inte det begärda administrationsanropet.',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'pAIoneer Labs GmbH:s Veridion-instans för medarbetarna i Webex, med YouTrack och en egen kunskapsbas; dess modellanrop går via Envoy AI Gateway.',
    companyWorkloads: 'Arbetslaster',
    companyTokensWindow: 'Tokens i det aktuella fönstret',
    companyBudget: 'Budget',
    companyBudgetDefault: 'standardbudget',
    companyCost30: 'Kostnad senaste 30 dagarna',
    openrouterTitle: 'Fakturerat av OpenRouter',
    openrouterRemaining: 'Kvarvarande kredit',
    openrouterOf: 'av',
    openrouterToday: 'I dag',
    openrouterWeek: 'Denna vecka',
    openrouterMonth: 'Denna månad',
    openrouterUnavailable: 'OpenRouter kan inte läsas just nu',
    openrouterNote: 'OpenRouters fakturering för plattformens nyckel, i amerikanska dollar; dag och vecka i UTC. De bokförda värdena nedan räknar bara svar som anger sin kostnad och är därför lägre.',
    companyRequests30: 'Modellanrop senaste 30 dagarna',
    companyCostNote: 'Kostnad i US-dollar som OpenRouter rapporterar den per anrop; Envoy AI Gateway bokför tokens på identiteten {identity}.',
    companyCostNotReported: 'inte rapporterad',
    companyPartUnavailable: 'kan inte nås',
    companyWebexTitle: 'Webex-bot',
    companyWebexSubtitle: 'Webex anropar webex.paioneer-labs.eu/hook; bryggan kontrollerar signatur och avsändare och lämnar bara tillåtna meddelanden till Veridion.',
    companyWebexBot: 'Bot',
    companyWebexWebhook: 'Webhook',
    companyWebexRegistered: 'registrerad',
    companyWebexNotRegistered: 'inte registrerad',
    companyWebexAccess: 'Tillåtna',
    companyWebexAnswered: 'Besvarade',
    companyWebexRejected: 'Avvisade',
    companyWebexFailed: 'Misslyckade',
    companyWebexRecent: 'Senaste leveranser',
    companyWebexTime: 'Tid',
    companyWebexOutcome: 'Utfall',
    companyWebexReason: 'Orsak',
    companyWebexSender: 'Avsändare',
    companyWebexEmpty: 'Ingen leverans sedan senaste start.',
    companyWebexNotConfigured: 'Webex-bryggan kan inte nås eller dess statusnyckel saknas i admin-API:t.',
    companyUsageTitle: 'Användning per person',
    companyUsageSubtitle: 'Modellanrop, tokens och kostnad för de senaste 30 dagarna ur instansens förbrukningsbok.',
    companyUsagePerson: 'Person',
    companyUsageCalls: 'Anrop',
    companyUsageTokens: 'Tokens',
    companyUsageCost: 'Kostnad (USD)',
    companyUsageEmpty: 'Inga modellanrop de senaste 30 dagarna.',
    companyWebexSendTitle: 'Skriv som boten',
    companyWebexSendPerson: 'Till en person',
    companyWebexSendRoom: 'I ett rum där boten finns',
    companyWebexSendEmail: 'E-postadress i Webex',
    companyWebexSendText: 'Meddelande (Markdown)',
    companyWebexSendButton: 'Skicka',
    companyWebexSendDone: 'Skickat.',
    companyWebexSendFailed: 'Misslyckades',
    companyWebexRooms: 'Botens rum',
    companyWebexRoomGroup: 'grupp',
    companyWebexRoomDirect: 'direkt',
    companyWebexRoomsEmpty: 'Boten finns ännu inte i något rum.',
    companyKnowledgeTitle: 'Kunskapsbas',
    companyKnowledgeSubtitle: 'Dokumenten i företagsinstansens kunskapsbas (Agentic RAG); orkestreraren söker i dem när ett samtalssteg kräver det. Phoenix loggar varje sökning.',
    companyKnowledgeDocument: 'Dokument',
    companyKnowledgeSize: 'Storlek',
    companyKnowledgeModified: 'Tillagt',
    companyKnowledgeDelete: 'Ta bort',
    companyKnowledgeDeleteConfirm: 'Ta bort {name} från kunskapsbasen?',
    companyKnowledgeUpload: 'Lägg till dokument',
    companyKnowledgeUploading: 'Laddar upp …',
    companyKnowledgeIntake: 'Intag',
    companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
    companyKnowledgeEmpty: 'Kunskapsbasen är tom.',
    companyKnowledgeNotConfigured: 'Kunskapsbasen är inte ansluten till admin-API:t.',
    companyGuestsTitle: 'Gäster med åtkomst',
    companyGuestsHint: 'Varje adress på {domains} får använda boten. Enskilda externa adresser lägger administratörer till här; ändringen gäller direkt.',
    companyGuestsEmail: 'E-postadress',
    companyGuestsAdd: 'Lägg till',
    companyGuestsRemove: 'Ta bort',
    companyGuestsRemoveConfirm: 'Återkalla åtkomsten till boten för {email}?',
    companyGuestsAddedBy: 'Tillagd av',
    companyGuestsAddedAt: 'Tillagd',
    companyGuestsEmpty: 'Inga gäster tillagda.',
    companyGuestsNotPersistent: 'Listan sparas inte: bryggan har ingen datakatalog.',
    companyGuestsLoadFailed: 'Den sparade listan gick inte att läsa; ingen gäst har åtkomst förrän nästa ändring.',
    companyErrorRecipientNotAllowed: 'Den här adressen får inte svara boten. Lägg först till den som gäst och skicka sedan.',
    companyErrorDomainAllowed: 'Adresser i den här domänen har redan åtkomst.',
    companyErrorInvalidEmail: 'Ogiltig e-postadress.',
    companyErrorAlreadyListed: 'Adressen finns redan på listan.',
    companyErrorStoreUnwritable: 'Listan kunde inte sparas.',
    smtmFilterTitle: 'SMTM-instrumentfilter',
    smtmFilterSubtitle: 'Tom inmatning visar alla instrument; flera instrumentnamn separeras med komma, till exempel EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
    smtmFilterPlaceholder: 'Instrumentnamn, kommaseparerade',
    smtmFilterApply: 'Tillämpa filter',
    smtmFilterClear: 'Rensa filter',
    smtmReportingTitle: 'SMTM-signalrapportering',
    smtmReportingSubtitle: 'Visar kvalificerade köpsignaler, deras utvärdering vid utgång och leveransstatus för automatiska aviseringar.',
    smtmReportingUnavailable: 'SMTM-rapportering inte tillgänglig',
    smtmReportingQualifiedSignals: 'Kvalificerade signaler',
    smtmReportingOpenSignals: 'Öppna signaler',
    smtmReportingResolvedSignals: 'Avslutade signaler',
    smtmReportingWins: 'Vinster',
    smtmReportingLosses: 'Förluster',
    smtmReportingWinRate: 'Träffsäkerhet',
    smtmReportingAverageActualReturn: 'Genomsnittlig faktisk avkastning',
    smtmReportingNetActualReturn: 'Netto faktisk avkastning',
    smtmReportingDeliveryFailed: 'Misslyckade leveranser',
    smtmReportingEntryTime: 'Ingångstid',
    smtmReportingExitTime: 'Utgångstid',
    smtmReportingExpectedReturn: 'Förväntad avkastning',
    smtmReportingActualReturn: 'Faktisk avkastning',
    smtmReportingSignalStatus: 'Signalstatus',
    smtmReportingNoSignals: 'Inga kvalificerade signaler lagrade ännu.',
    smtmReportingPendingDeliveries: 'Väntande leveranser',
    smtmReportingFailedDeliveries: 'Misslyckade leveranser',
    smtmReportingDeliveryError: 'Leveransfel',
    smtmTrainingTitle: 'SMTM-träning och modeller',
    smtmTrainingSubtitle: 'Visar träningskvalitet, modellernas tillstånd och artefakter publicerade av träningstjänsten.',
    smtmTrainingUnavailable: 'SMTM-träning inte tillgänglig',
    smtmTrainingModels: 'Modeller',
    smtmTrainingOnlineModels: 'Modeller online',
    smtmTrainingFailedModels: 'Misslyckade modeller',
    smtmTrainingStaleModels: 'Föråldrade modeller',
    smtmTrainingAverageMae: 'Genomsnittlig MAE',
    smtmTrainingAverageRmse: 'Genomsnittlig RMSE',
    smtmTrainingAverageR2: 'Genomsnittlig R²',
    smtmTrainingAverageMase: 'Genomsnittlig MASE',
    smtmTrainingAverageHitRate: 'Genomsnittlig riktningsträff',
    smtmTrainingHitRate: 'Riktningsträff',
    smtmTrainingLastSuccess: 'Senaste lyckade träning',
    smtmTrainingResolution: 'Upplösning / horisont',
    smtmTrainingConsoleTitle: 'SMTM-träningskonsol',
    smtmTrainingConsoleSubtitle: 'Direktvisning av träningstjänstens utdata.',
    smtmTrainingConsoleUnavailable: 'SMTM-träningskonsolen inte tillgänglig',
    smtmTrainingConsoleEmpty: 'Ingen träningsutdata tillgänglig ännu.',
    smtmRuntimeTitle: 'SMTM-runtime',
    smtmRuntimeSubtitle: 'Global horisont, ombyggnadstillstånd och prognosgrind för det live SMTM-systemet.',
    smtmRuntimeUnavailable: 'SMTM-runtime inte tillgänglig',
    smtmRuntimeForecastHorizon: 'Prognoshorisont',
    smtmRuntimeResolution: 'Upplösning',
    smtmRuntimeConfigVersion: 'Konfigurationsversion',
    smtmRuntimePredictionGate: 'Prognosgrind',
    smtmRuntimeRebuild: 'Ombyggnad',
    smtmRuntimeStateOpen: 'öppen',
    smtmRuntimeStateClosed: 'stängd',
    smtmRuntimeStateActive: 'aktiv',
    smtmRuntimeStateIdle: 'vilande',
    smtmRuntimeForecastHorizonMinutes: 'Prognoshorisont i minuter',
    smtmRuntimeResolutionMinutes: 'Upplösning i minuter',
    smtmRuntimeRequireCompletedBars: 'Kräv avslutade staplar',
    smtmRuntimePredictionGateOpen: 'Prognosgrinden öppen',
    smtmRuntimeRebuildActive: 'Ombyggnad aktiv',
    smtmRuntimeSaving: 'Sparar runtime...',
    smtmRuntimeSave: 'Spara runtime-inställningar',
    smtmRuntimeReset: 'Kasta runtime-ändringar',
    smtmRuntimeSaved: 'SMTM-runtime-inställningar sparade.',
    smtmTrainingRows: 'Tränings-/testrader',
    smtmTrainingMetrics: 'Mätvärden',
    smtmTrainingIssues: 'Träningsproblem',
    smtmTrainingLlmFeatures: 'LLM-egenskaper',
    smtmTrainingNoModels: 'Inga cachade träningsmodeller ännu.',
    smtmDirection: 'Riktning',
    smtmSentiment: 'Sentiment',
    smtmDeliveryStage: 'Steg',
    smtmDeliveryRecipient: 'Mottagare',
    mailSettingsSaved: 'E-postinställningar sparade.',
    mailTestSent: 'Testmeddelande skickat.',
    userCreatedSuccess: 'Användaren skapades.',
    userUpdatedSuccess: 'Användaren uppdaterades.',
    userDeletedSuccess: 'Användaren togs bort.',
    deleteUser: 'Ta bort användare',
    roleLabels: {
      admin: 'Administratör',
      pro: 'Pro',
      tester: 'Testare',
      user: 'Användare'
    },
    statusLabels: {
      pending_email_verification: 'Väntar på e-postverifiering',
      pending_mfa: 'Väntar på 2FA',
      active: 'Aktiv',
      locked: 'Låst',
      disabled: 'Inaktiverad'
    }
  },
  footer: {
    managingDirectors: 'Verkställande direktörer',
    servicesTitle: 'Tjänster',
    legal: { title: 'Juridiskt', imprint: 'Juridisk information', privacy: 'Integritetspolicy', aiTransparency: 'AI-transparens', cookieSettings: 'Cookieinställningar', terms: 'Användarvillkor' },
    copyright: 'Alla rättigheter förbehållna.'
  },
  auth: {
    validating: 'Validerar...',
    errors: {
      registrationFailed: 'Registreringen misslyckades: ',
      unknownError: 'Okänt fel'
    }
  },
  account: {
    username: 'Användarnamn',
    email: 'E-post',
    roles: 'Roller',
    manageText: 'Lösenord, tvåfaktorsautentisering, aktiva sessioner och e-postadress ändrar du i kontohanteringen.',
    manageButton: 'Öppna kontohanteringen',
    signedOut: 'Du är inte inloggad.'
  },
  cookies: {
    title: 'Integritetsinställningar',
    description: 'Vi analyserar besöksstatistik med metoder för maskininlärning för att förbättra vår webbplats. Med ditt samtycke behandlar vi för detta användnings- och enhetsdata, inklusive din IP-adress, och känner igen din webbläsare vid senare besök. Samtycket är frivilligt och kan när som helst återkallas under ”{settings}”. Detaljer, även om överföring till tredjeländer, finns i integritetspolicyn.',
    necessary: {
      title: 'Nödvändiga',
      description: 'Krävs för att webbplatsen ska fungera, till exempel språkval och lagring av detta val.'
    },
    statistics: {
      title: 'Statistik',
      description: 'Sidvisningar och användning av webbplatsen, utan igenkänning och utan lagring av IP-adressen.'
    },
    marketing: {
      title: 'Analys och maskininlärning',
      description: 'Igenkänning vid senare besök samt analys av IP-adressen (ungefärlig plats, nätoperatör, organisation) och av enhetsegenskaper; sparas i upp till tolv månader efter det senaste besöket. Därvid överförs din IP-adress även till internetregister i USA, Australien och Mauritius, för vilka ingen adekvat dataskyddsnivå har fastställts; det finns en risk för åtkomst från myndigheter där och för att det blir svårare för dig att hävda dina rättigheter.'
    },
    acceptAll: 'Godkänn alla',
    rejectAll: 'Endast nödvändiga',
    settings: 'Inställningar',
    save: 'Spara val',
    alwaysOn: 'Alltid aktiva'
  },
  pages: {
    teaching: {
      hero: { title: 'Utbildning i edge-AI & EU AI Act', subtitle: 'AI-rådgivning för företag • Edge-utveckling • Rättssäker implementering' },
      intro: 'Specialiserade AI-utbildningar för chefer, projektledare och utvecklingsteam. Från strategisk rådgivning till teknisk implementering - i enlighet med EU AI Act.',
      eu_ai_act: { title: 'Efterlevnad av EU AI Act & edge computing', subtitle: 'Rättssäker AI-implementering med lokal databehandling', description: 'EU AI Act fastställer strikta regler för användningen av artificiell intelligens i Europa. Edge computing är den idealiska lösningen: känsliga data stannar lokalt, regelefterlevnaden förenklas och du behåller kontrollen över AI-systemen.', benefits: ['Dataskydd genom lokal bearbetning', 'Mindre komplex regelefterlevnad', 'Full kontroll över AI-beslut', 'Transparens och spårbarhet', 'Minimerade juridiska risker', 'Oberoende av molnleverantörer'], highlight: 'Edge computing + EU AI Act = rättssäker AI utan kompromisser' },
      offerings: { title: 'Kursutbud', categories: [{ title: 'Artificiell intelligens & maskininlärning', icon: 'brain', topics: ['Generativ AI & stora språkmodeller (edge & moln)', 'Klassisk maskininlärning (edge-optimerad)', 'Djupinlärning & neurala nätverk (driftsättning på edge)', 'Datorseende & NLP (lösningar för edge)', 'RAG-system & finjustering av LLM:er (edge & moln)', 'Autonoma AI-agenter (edge computing)', 'Efterlevnad av EU AI Act & rättssäkerhet'] }, { title: 'Data science & statistik', icon: 'chart', topics: ['Deskriptiv statistik & inferensstatistik', 'Datamodellering & dataanalys', 'Tidsserieanalys', 'Ekonometri för företagsekonomi och nationalekonomi', 'Biostatistik för naturvetenskaperna', 'A/B-testning & experimentdesign'] }, { title: 'Mjukvaruarkitektur & säkerhet', icon: 'shield', topics: ['Modulära arkitekturer', 'Lös koppling & Clean Code', 'Design av mikrotjänster', 'IT-säkerhet & regelefterlevnad', 'DevOps & CI/CD', 'Molnarkitekturer'] }] },
      target_groups: { title: 'Målgrupper', groups: [{ title: 'Företagsledning & beslutsfattare', description: 'Strategisk AI-rådgivning, kostnadsanalys och investeringsbeslut', formats: ['Ledningsbriefingar', 'ROI-analyser', 'Strategirådgivning'], focus: 'Affärscase, efterlevnad av EU AI Act, budgetplanering' }, { title: 'Projektledare & projektansvariga', description: 'Ledning av AI-projekt, teknikval och implementeringsstrategier', formats: ['Workshoppar för ledare', 'Teknikutvärderingar', 'Framtagning av färdplaner'], focus: 'Projektplanering, leverantörsval, riskhantering' }, { title: 'IT-utvecklare & ingenjörer', description: 'Praktisk edge-AI-utveckling, teknisk implementering och driftsättning', formats: ['Tekniska djupdykningar', 'Kodgranskningar', 'Arkitekturworkshoppar'], focus: 'Edge computing, finjustering av LLM:er, systemintegration' }, { title: 'Verksamhetsspecialister', description: 'AI-förståelse, promptteknik och praktisk tillämpning i det dagliga arbetet', formats: ['Användarutbildningar', 'Promptworkshoppar', 'Utveckling av användningsfall'], focus: 'Praktisk tillämpning, integration i arbetsflöden, ökad produktivitet' }, { title: 'Studenter & akademiker', description: 'Universitetsundervisning, studiehandledning och handledning av akademiska projekt', formats: ['Föreläsningar', 'Studiehandledning', 'Uppsatshandledning'], focus: 'Statistik, ekonometri, forskningsmetodik' }] },
      expertise: { title: 'Teknisk expertis', items: ['Framtagning av strategiska AI-färdplaner för företag', 'Edge-AI-system med RAG/GRAG-arkitekturer och finjustering med LoRA/QLoRA', 'Strategier för efterlevnad av EU AI Act och rättssäker implementering', 'ROI-analys och investeringsplanering för AI-projekt', 'Autonoma AI-agenter med verktygsuppsättningar och resonemangsförmåga', 'Förändringsledning vid införande av AI i organisationer', 'Moln- och on-premises-strategier (Azure, STACKIT)', 'Prompt engineering och optimering av arbetsflöden'] },
      technologies: { title: 'Teknikstack', list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata' },
      clients: { title: 'Branscher & institutioner', sectors: ['Sjukförsäkring', 'Förlag', 'Bank & fintech', 'Industri & IoT', 'Forskning & universitet', 'Konsultverksamhet', 'Startupbolag'] },
      workshops: { title: 'Utbildningsformat', formats: [{ title: 'Ledningsbriefing', duration: '2-4 timmar', description: 'Strategisk översikt för ledningen med fokus på ROI och EU AI Act' }, { title: 'Workshop för ledare', duration: '1-2 dagar', description: 'Utbildning av projektledare i AI-implementering och förändringsledning' }, { title: 'Teknisk djupdykning', duration: '2-5 dagar', description: 'Praktisk edge-AI-utveckling för IT-team och ingenjörer' }, { title: 'Användarutbildning', duration: '0,5-1 dag', description: 'Praktisk AI-användning för verksamhetsspecialister' }, { title: 'Individuell coachning', duration: 'Efter behov', description: 'Personligt stöd och projektstöd' }] },
      sidebar: {languagesLabel: 'Språk:', languagesValue: 'DE / EN / NL', focusLabel: 'Fokus:', specializationTitle: 'Specialisering', specializationItems: ['Edge-AI för lokal databehandling utan molnberoende', 'Implementering i enlighet med EU AI Act för rättssäkerhet'], benefitsTitle: 'Fördelar', benefits: ['Anpassat efter målgruppen', 'Direkt tillämpbart', 'ROI-orienterat', 'På distans eller på plats'] },
      cta: { title: 'Redo för strategisk AI-transformation?', description: 'Från rådgivning på ledningsnivå till teknisk implementering - låt oss prata om just dina behov.', button: 'Begär rådgivning', email: 'info@paioneer.eu', subject: 'Förfrågan om utbildning' }
    },
    agenticdev: {
      seo: { title: 'Intent-Driven Development (IDD) för Agentic Coding | pAIoneer Labs GmbH', description: 'Intent-Driven Development gör AI-stödd mjukvaruutveckling kontrollerbar: mening, beslut och scenarier blir operativa artefakter för Agentic Coding.', keywords: 'Intent-Driven Development, Intent Driven Development, IDD, Agentic Coding, agentisk mjukvaruutveckling, AI-stödd mjukvaruutveckling, Vibe Coding, Spec-Driven Development, Prompt Engineering, kravhantering för AI', ogTitle: 'Intent-Driven Development: mening före implementering', ogDescription: 'IDD operationaliserar kontexten innan kod skrivs: Intent, Decisions och Scenarios blir projektminnet för agentisk mjukvaruutveckling.', twitterTitle: 'Intent-Driven Development (IDD) för Agentic Coding', twitterDescription: 'Kontrollerbar kod i stället för promptkaos: IDD gör mening, beslut och scenarier till operativa artefakter.', url: 'https://paioneer-labs.eu/agenticdev', structuredData: { '@context': 'https://schema.org', '@type': 'Service', name: 'Intent-Driven Development (IDD) för Agentic Coding', serviceType: 'Agentisk mjukvaruutveckling och AI-stödda utvecklingsprocesser', description: 'Rådgivning och implementering för Intent-Driven Development, IDD Vaults, arbetsflöden för Agentic Coding och verifierbar AI-stödd mjukvaruutveckling.', provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' }, areaServed: 'DE, NL, EU', url: 'https://paioneer-labs.eu/agenticdev' } },
      hero: { eyebrow: 'Agentic Coding behöver explicit kontext', title: 'Intent-Driven Development', claim: 'Mening före implementering.', lead: 'AI skriver kod. IDD ser till att den arbetar med rätt problem. Intent-Driven Development gör mål, gränser, beslut och scenarier till operativa artefakter för agentisk mjukvaruutveckling.' },
      implicitContextProblem: { title: 'Risken är implicit kontext', intro: 'Den verkliga risken i AI-stödd mjukvaruutveckling är inte kod som saknas. Risken är kontext som ligger dold i någons huvud, i en chatthistorik eller utspridd över olika ärenden.', items: [{ title: 'Otydligt uppdrag', description: 'Promptar beskriver ofta en lösning, men inte målet, icke-målen, framgångskriterierna och antagandena. AI:n arbetar då snabbt, men inte nödvändigtvis i rätt riktning.' }, { title: 'Oavsiktlig arkitektur', description: 'Teknikbeslut fattas i förbigående: persistens, modellval, felfall och drift avgörs implicit i stället för att styras medvetet.' }, { title: 'Overifierbart resultat', description: 'Utan scenarier och acceptanskriterier förblir det oklart om koden faktiskt beter sig korrekt eller bara ser rimlig ut.' }], resolution: 'IDD löser just det problemet: först operationaliseras meningen, därefter härleds koden ur den.' },
      antiVibeCoding: { title: 'Vibe Coding är ingen utvecklingsprocess', description: 'Magkänsla kan räcka för demor. Den räcker inte för programvara med drift, underhåll, säkerhet, kostnader och ansvar. Agenter behöver inte fler vibbar; de behöver explicit kontext.', contrasts: ['Vibe Coding skapar rörelse. IDD skapar riktning.', 'Promptning skapar svar. IDD skapar projektminne.', 'Agentic Coding utan IDD förblir aktivitet. Agentic Coding med IDD blir kontrollerbar utveckling.'] },
      principle: { title: 'Dokumentation är ingen biprodukt', thesis: 'I IDD är dokumentationen en operativ artefakt.', description: 'Dokumentation är inte rapportering. Den är arbetsytan där mål, gränser, beslut och förväntat beteende görs explicita innan agenter implementerar.', pillarsTitle: 'Intent. Decisions. Scenarios. Code.', pillarsIntro: 'IDD reducerar inte mjukvaruutveckling till promptar. IDD gör projektets mening explicit och härleder en verifierbar implementering ur den.', pillars: [{ title: 'Intent', description: 'Vad ska uppnås, vad ligger uttryckligen utanför ramen och hur känner vi igen framgång?' }, { title: 'Decisions', description: 'Vilka viktiga beslut har fattats, i vilket sammanhang och med vilka konsekvenser?' }, { title: 'Scenarios', description: 'Vilket beteende förväntas i normalfall, gränsfall, felfall och acceptanssituationer?' }, { title: 'Code', description: 'Implementeringen tas fram ur dokumenterad mening och kontrolleras mot scenarier och verifieringssteg.' }] },
      vault: { title: 'IDD Vault: projektminne i stället för prompthistorik', description: 'IDD Vault bevarar relevant kontext där agenter och människor kan återanvända den. Inte fler filer än nödvändigt. Varje fil har en tydlig funktion.', rule: 'Få artefakter. Tydligt syfte. Varaktig kontext.', effect: 'Vault förhindrar att avgörande kontext försvinner i chatten, i någons huvud eller i utspridda ärenden.', treeLines: ['/project', '  /idd_vault', '    intent.md       # mål, icke-mål, framgångskriterier, antaganden', '    decisions.md    # beslut med kontext, motivering, konsekvenser', '    scenarios.md    # beteende, gränsfall, acceptanskriterier', '  /code', '  AGENTS.md         # regler och förväntningar för kodagenter', '  README.md         # ingång, installation, driftläge, gränser'] },
      outputs: { title: 'Inte text. Kontrollerbar kod.', description: 'IDD-filerna är ingen rapport. De är indata för konkret implementeringsarbete och för att föra tillbaka insikter till projektet.', items: [{ file: 'intent.md', result: 'Omfattning', description: 'Ändpunkter, datamodell, framgångskriterier, icke-mål och antaganden blir synliga som ram för utvecklingen.' }, { file: 'decisions.md', result: 'Arkitektur', description: 'Teknik, drift, persistens, modellval och avvägningar motiveras i stället för att avgöras i förbigående.' }, { file: 'scenarios.md', result: 'Tester', description: 'Acceptanstester, felfall, tillståndsövergångar och gränsfall tas fram före eller under implementeringen.' }, { file: 'AGENTS.md', result: 'Kodkvalitet', description: 'Regler, mönster, begränsningar, migreringar, OpenAPI och förväntade resultat blir explicita för agenterna.' }, { file: 'README.md', result: 'Ingång', description: 'Installation, driftläge, gränser och exempelflöden förblir begripliga för människor och agenter.' }, { file: 'Code', result: 'Återkoppling', description: 'Insikter från implementering och verifiering förs tillbaka till Vault, testerna och nästa iteration.' }] },
      comparison: { title: 'IDD börjar före specifikationen', intro: 'Spec-Driven Development är starkt när målet redan är tekniskt precist och stabilt. IDD börjar tidigare: där domän, antaganden, avvägningar och felfall fortfarande måste göras explicita.', columns: ['Metod', 'Kärna', 'Styrka', 'Begränsning'], rows: [{ approach: 'Promptning', center: 'Inmatning till en modell', strength: 'Snabbt och direkt', limit: 'Flyktigt, ofullständigt och svårt att verifiera' }, { approach: 'Vibe Coding', center: 'Magkänsla och iteration', strength: 'Användbart för experiment och demor', limit: 'Ingen tillförlitlig styrning för programvara som någon ska kunna stå till svars för' }, { approach: 'Spec-Driven Development', center: 'Tekniskt kontrakt', strength: 'Konsistens mot en redan definierad specifikation', limit: 'Fel problem kan implementeras formellt korrekt' }, { approach: 'Intent-Driven Development', center: 'Mening, mål och beslut', strength: 'Klargör kontext, avvägningar och gränser före implementeringen', limit: 'Kräver disciplinerad vård av kontexten och validering' }], summary: 'Specifikationer säger vad som tekniskt måste vara sant. IDD förklarar varför just den här riktningen ska byggas.' },
      workflow: { title: 'Klargör. Besluta. Formulera. Bygg. Återkoppla.', description: 'IDD är inte vattenfall. IDD är små, kontrollerade iterationer med varaktig kontext.', steps: [{ title: 'Klargör intentionen', description: 'Mål, icke-mål, framgångskriterier och antaganden blir synliga innan kod skrivs.' }, { title: 'Dokumentera beslut', description: 'Arkitektur- och produktbeslut dokumenteras med kontext, motivering och konsekvenser.' }, { title: 'Formulera scenarier', description: 'Normalt beteende, gränsfall, felfall och acceptanskriterier beskrivs så att de går att verifiera.' }, { title: 'Låt agenter implementera', description: 'AI-agenter arbetar utifrån explicit kontext i stället för isolerade promptar.' }, { title: 'Verifiera och återkoppla', description: 'Insikter från kod, tester och drift uppdaterar Vault och nästa iteration.' }] },
      impact: { title: 'Därför spelar det roll i verkliga projekt', description: 'IDD gör att AI-stödd utveckling går att knyta ihop med team, drift och kvalitetssäkring.', items: ['Mindre omarbete eftersom mål och icke-mål är synliga.', 'Bättre arkitektur eftersom besluten är motiverade.', 'Bättre tester eftersom scenarierna finns före koden.', 'Bättre samarbete eftersom kontexten inte försvinner i chatten.', 'Bättre agentresultat eftersom varje steg bygger på explicita artefakter.'] },
      contact: { title: 'Inför IDD i agentiska utvecklingsprocesser', description: 'Om AI-stödd utveckling ska bli mer än experiment behövs en operativ modell för kontext.', details: 'Vi hjälper till att bygga upp IDD Vaults, agentregler, scenarier och verifierbara utvecklingsflöden.', button: 'Diskutera IDD', subject: 'Samtal om Intent-Driven Development', email: 'info@paioneer.eu' }
    },
    impressum: injectPersonalData('sv', baseTranslationSV)
  }
};
